/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(3517));
	else {}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_688__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_688__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_688__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_688__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_688__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_688__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__nested_webpack_require_688__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__nested_webpack_require_688__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __nested_webpack_require_688__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__nested_webpack_require_688__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __nested_webpack_require_688__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_688__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_688__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_688__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_688__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_688__(__nested_webpack_require_688__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __nested_webpack_require_4164__) {

"use strict";

var LIBRARY = __nested_webpack_require_4164__("2d00");
var $export = __nested_webpack_require_4164__("5ca1");
var redefine = __nested_webpack_require_4164__("2aba");
var hide = __nested_webpack_require_4164__("32e9");
var Iterators = __nested_webpack_require_4164__("84f2");
var $iterCreate = __nested_webpack_require_4164__("41a0");
var setToStringTag = __nested_webpack_require_4164__("7f20");
var getPrototypeOf = __nested_webpack_require_4164__("38fd");
var ITERATOR = __nested_webpack_require_4164__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __nested_webpack_require_7070__) {

var toInteger = __nested_webpack_require_7070__("4588");
var defined = __nested_webpack_require_7070__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __nested_webpack_require_7783__) {

"use strict";

var at = __nested_webpack_require_7783__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __nested_webpack_require_8134__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __nested_webpack_require_8134__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __nested_webpack_require_8593__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __nested_webpack_require_8593__("ce10");
var enumBugKeys = __nested_webpack_require_8593__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __nested_webpack_require_8892__) {

var dP = __nested_webpack_require_8892__("86cc");
var anObject = __nested_webpack_require_8892__("cb7c");
var getKeys = __nested_webpack_require_8892__("0d58");

module.exports = __nested_webpack_require_8892__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __nested_webpack_require_9392__) {

"use strict";

__nested_webpack_require_9392__("b0c5");
var redefine = __nested_webpack_require_9392__("2aba");
var hide = __nested_webpack_require_9392__("32e9");
var fails = __nested_webpack_require_9392__("79e5");
var defined = __nested_webpack_require_9392__("be13");
var wks = __nested_webpack_require_9392__("2b4c");
var regexpExec = __nested_webpack_require_9392__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __nested_webpack_require_12849__) {

var isObject = __nested_webpack_require_12849__("d3f4");
var document = __nested_webpack_require_12849__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __nested_webpack_require_13233__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __nested_webpack_require_13233__("2d95");
var TAG = __nested_webpack_require_13233__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __nested_webpack_require_14160__) {

var global = __nested_webpack_require_14160__("7726");
var hide = __nested_webpack_require_14160__("32e9");
var has = __nested_webpack_require_14160__("69a8");
var SRC = __nested_webpack_require_14160__("ca5a")('src');
var $toString = __nested_webpack_require_14160__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__nested_webpack_require_14160__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __nested_webpack_require_15334__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __nested_webpack_require_15334__("cb7c");
var dPs = __nested_webpack_require_15334__("1495");
var enumBugKeys = __nested_webpack_require_15334__("e11e");
var IE_PROTO = __nested_webpack_require_15334__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __nested_webpack_require_15334__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __nested_webpack_require_15334__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __nested_webpack_require_16945__) {

var store = __nested_webpack_require_16945__("5537")('wks');
var uid = __nested_webpack_require_16945__("ca5a");
var Symbol = __nested_webpack_require_16945__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __nested_webpack_require_17667__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __nested_webpack_require_17667__("5ca1");
var context = __nested_webpack_require_17667__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __nested_webpack_require_17667__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __nested_webpack_require_18235__) {

var dP = __nested_webpack_require_18235__("86cc");
var createDesc = __nested_webpack_require_18235__("4630");
module.exports = __nested_webpack_require_18235__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __nested_webpack_require_18611__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __nested_webpack_require_18611__("69a8");
var toObject = __nested_webpack_require_18611__("4bf8");
var IE_PROTO = __nested_webpack_require_18611__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __nested_webpack_require_19205__) {

"use strict";

var create = __nested_webpack_require_19205__("2aeb");
var descriptor = __nested_webpack_require_19205__("4630");
var setToStringTag = __nested_webpack_require_19205__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__nested_webpack_require_19205__("32e9")(IteratorPrototype, __nested_webpack_require_19205__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __nested_webpack_require_19831__) {

// 19.1.2.14 Object.keys(O)
var toObject = __nested_webpack_require_19831__("4bf8");
var $keys = __nested_webpack_require_19831__("0d58");

__nested_webpack_require_19831__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __nested_webpack_require_20609__) {

// 7.1.13 ToObject(argument)
var defined = __nested_webpack_require_20609__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __nested_webpack_require_20831__) {

var MATCH = __nested_webpack_require_20831__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __nested_webpack_require_21176__) {

"use strict";


var regexpFlags = __nested_webpack_require_21176__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __nested_webpack_require_23109__) {

var core = __nested_webpack_require_23109__("8378");
var global = __nested_webpack_require_23109__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __nested_webpack_require_23109__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __nested_webpack_require_23642__) {

var global = __nested_webpack_require_23642__("7726");
var core = __nested_webpack_require_23642__("8378");
var hide = __nested_webpack_require_23642__("32e9");
var redefine = __nested_webpack_require_23642__("2aba");
var ctx = __nested_webpack_require_23642__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __nested_webpack_require_25367__) {

// most Object methods by ES6 should accept primitives
var $export = __nested_webpack_require_25367__("5ca1");
var core = __nested_webpack_require_25367__("8378");
var fails = __nested_webpack_require_25367__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __nested_webpack_require_25845__) {

"use strict";


var classof = __nested_webpack_require_25845__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __nested_webpack_require_26551__) {

var shared = __nested_webpack_require_26551__("5537")('keys');
var uid = __nested_webpack_require_26551__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __nested_webpack_require_26811__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __nested_webpack_require_26811__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __nested_webpack_require_27194__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __nested_webpack_require_27194__("5ca1");
var $includes = __nested_webpack_require_27194__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__nested_webpack_require_27194__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __nested_webpack_require_27659__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __nested_webpack_require_27659__("626a");
var defined = __nested_webpack_require_27659__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __nested_webpack_require_28155__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __nested_webpack_require_28155__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __nested_webpack_require_28898__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __nested_webpack_require_28898__("0d58");
var gOPS = __nested_webpack_require_28898__("2621");
var pIE = __nested_webpack_require_28898__("52a7");
var toObject = __nested_webpack_require_28898__("4bf8");
var IObject = __nested_webpack_require_28898__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __nested_webpack_require_28898__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __nested_webpack_require_30635__) {

var toInteger = __nested_webpack_require_30635__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __nested_webpack_require_31112__) {

var def = __nested_webpack_require_31112__("86cc").f;
var has = __nested_webpack_require_31112__("69a8");
var TAG = __nested_webpack_require_31112__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __nested_webpack_require_31751__) {

var anObject = __nested_webpack_require_31751__("cb7c");
var IE8_DOM_DEFINE = __nested_webpack_require_31751__("c69a");
var toPrimitive = __nested_webpack_require_31751__("6a99");
var dP = Object.defineProperty;

exports.f = __nested_webpack_require_31751__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __nested_webpack_require_32441__) {

// optional / simple context binding
var aFunction = __nested_webpack_require_32441__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __nested_webpack_require_33048__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __nested_webpack_require_33048__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __nested_webpack_require_33048__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __nested_webpack_require_33448__) {

// 7.1.15 ToLength
var toInteger = __nested_webpack_require_33448__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __nested_webpack_require_33750__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__nested_webpack_require_33750__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __nested_webpack_require_34139__) {

"use strict";


var anObject = __nested_webpack_require_34139__("cb7c");
var toObject = __nested_webpack_require_34139__("4bf8");
var toLength = __nested_webpack_require_34139__("9def");
var toInteger = __nested_webpack_require_34139__("4588");
var advanceStringIndex = __nested_webpack_require_34139__("0390");
var regExpExec = __nested_webpack_require_34139__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__nested_webpack_require_34139__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __nested_webpack_require_38885__) {

// 7.2.8 IsRegExp(argument)
var isObject = __nested_webpack_require_38885__("d3f4");
var cof = __nested_webpack_require_38885__("2d95");
var MATCH = __nested_webpack_require_38885__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __nested_webpack_require_39282__) {

var $iterators = __nested_webpack_require_39282__("cadf");
var getKeys = __nested_webpack_require_39282__("0d58");
var redefine = __nested_webpack_require_39282__("2aba");
var global = __nested_webpack_require_39282__("7726");
var hide = __nested_webpack_require_39282__("32e9");
var Iterators = __nested_webpack_require_39282__("84f2");
var wks = __nested_webpack_require_39282__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __nested_webpack_require_41209__) {

"use strict";

var regexpExec = __nested_webpack_require_41209__("520a");
__nested_webpack_require_41209__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __nested_webpack_require_41706__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __nested_webpack_require_41706__("6821");
var toLength = __nested_webpack_require_41706__("9def");
var toAbsoluteIndex = __nested_webpack_require_41706__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_42729__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __nested_webpack_require_42729__.d(__nested_webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __nested_webpack_require_42729__("a481");
/* harmony import */ var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__nested_webpack_require_42729__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __nested_webpack_require_42729__("c8ba")))

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __nested_webpack_require_44512__) {

module.exports = !__nested_webpack_require_44512__("9e1e") && !__nested_webpack_require_44512__("79e5")(function () {
  return Object.defineProperty(__nested_webpack_require_44512__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __nested_webpack_require_45568__) {

"use strict";

var addToUnscopables = __nested_webpack_require_45568__("9c6c");
var step = __nested_webpack_require_45568__("d53b");
var Iterators = __nested_webpack_require_45568__("84f2");
var toIObject = __nested_webpack_require_45568__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __nested_webpack_require_45568__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __nested_webpack_require_46777__) {

var isObject = __nested_webpack_require_46777__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __nested_webpack_require_47019__) {

var has = __nested_webpack_require_47019__("69a8");
var toIObject = __nested_webpack_require_47019__("6821");
var arrayIndexOf = __nested_webpack_require_47019__("c366")(false);
var IE_PROTO = __nested_webpack_require_47019__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __nested_webpack_require_47655__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __nested_webpack_require_47655__("aae3");
var defined = __nested_webpack_require_47655__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __nested_webpack_require_48796__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __nested_webpack_require_48796__("5ca1");
var toLength = __nested_webpack_require_48796__("9def");
var context = __nested_webpack_require_48796__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __nested_webpack_require_48796__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __nested_webpack_require_50913__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __nested_webpack_require_50913__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __nested_webpack_require_50913__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __nested_webpack_require_51166__) {

module.exports = __nested_webpack_require_51166__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __nested_webpack_require_51344__) {

var document = __nested_webpack_require_51344__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __nested_webpack_exports__, __nested_webpack_require_51548__) {

"use strict";
// ESM COMPAT FLAG
__nested_webpack_require_51548__.r(__nested_webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __nested_webpack_require_51548__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __nested_webpack_require_51548__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __nested_webpack_require_51548__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __nested_webpack_require_51548__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __nested_webpack_require_51548__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __nested_webpack_require_51548__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __nested_webpack_require_51548__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __nested_webpack_require_51548__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __nested_webpack_require_51548__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __nested_webpack_require_51548__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__nested_webpack_require_51548__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __nested_webpack_require_51548__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __nested_webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vuedraggable.umd.js.map

/***/ }),

/***/ 445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_FunnelsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FunnelsView.vue?vue&type=template&id=b9555daa
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100"},[_c('FunnelViews')],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/FunnelViews/FunnelViews.vue + 3 modules
var FunnelViews = __webpack_require__(6615);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FunnelsView.vue?vue&type=script&lang=ts



var FunnelsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FunnelsView, _super);
    function FunnelsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FunnelsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FunnelViews: FunnelViews/* default */.A
            }
        })
    ], FunnelsView);
    return FunnelsView;
}(lib/* Vue */.lD));
/* harmony default export */ var FunnelsViewvue_type_script_lang_ts = (FunnelsView);

;// ./src/views/FunnelsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_FunnelsViewvue_type_script_lang_ts = (FunnelsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/FunnelsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_FunnelsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_FunnelsView = (component.exports);

/***/ }),

/***/ 521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ needFetchOpportunity; },
/* harmony export */   iU: function() { return /* binding */ fetchOpportunity; },
/* harmony export */   vc: function() { return /* binding */ opportunityRelations; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var opportunityRelations = [
    'step', 'category', 'funnel', 'teamUser', 'customer', 'customer_child', 'contact', 'customFields', 'linked_documents',
    'customer.datas', 'customer_child.datas', 'loss_reason'
];
var needFetchOpportunity = function (opportunity) {
    return !opportunityRelations.every(function (relation) { return relation in opportunity; });
};
var fetchOpportunity = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwOpportunities.axios.get('/opportunity/' + id, {
                    params: {
                        include: opportunityRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Params_Params; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Params/Params.vue?vue&type=template&id=21a3fed4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('b-card',[_c('input',{attrs:{"type":"hidden","name":"configs[opportunity_select_all_customer]"},domProps:{"value":_vm.localConfig.opportunity_select_all_customer}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.opportunity_select_all_customer),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_select_all_customer", $$v)},expression:"localConfig.opportunity_select_all_customer"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.params.allowAllCustomer'))+" ")]),_c('b-form-group',{staticClass:"mt-3",attrs:{"label":_vm.$t('opportunities.params.linkedDocumentTitle')}},[_c('input',{attrs:{"type":"hidden","name":"configs[opportunity_linked_document_title]"},domProps:{"value":_vm.localConfig.opportunity_linked_document_title}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.opportunity_linked_document_title),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_linked_document_title", $$v)},expression:"localConfig.opportunity_linked_document_title"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.params.linkedDocumentShowTitle'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"configs[opportunity_linked_document_date_amount]"},domProps:{"value":_vm.localConfig.opportunity_linked_document_date_amount}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.opportunity_linked_document_date_amount),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_linked_document_date_amount", $$v)},expression:"localConfig.opportunity_linked_document_date_amount"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.params.linkedDocumentShowDateAmount'))+" ")])],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.params.referenceTitle'))+" ")]),_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.params.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references",staticStyle:{"white-space":"nowrap"},attrs:{"responsive":"sm"}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.params.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceTypeNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.params.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[opportunity_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.opportunity_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_reference_prefix", $$v)},expression:"localConfig.opportunity_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.opportunity_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_reference_mode", $$v)},expression:"localConfig.opportunity_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[opportunity_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.opportunity_reference_mode !== 0},model:{value:(_vm.localConfig.opportunity_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_reference_number", $$v)},expression:"localConfig.opportunity_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[opportunity_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.opportunity_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "opportunity_reference_length", $$v)},expression:"localConfig.opportunity_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.opportunityReferenceExample))])])])]),_c('p',{staticClass:"mt-2 mb-0 text-center"},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Params/Params.ts?vue&type=script&lang=ts&external





var Params = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Params, _super);
    function Params() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        return _this;
    }
    Params.prototype.pad = function (number, length) {
        if (!length) {
            return null;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    Params.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return null;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    Object.defineProperty(Params.prototype, "opportunityReferenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.opportunity_reference_prefix, this.localConfig.opportunity_reference_number, this.localConfig.opportunity_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Params.prototype, "numberTypes", {
        get: function () {
            return [
                { id: 0, label: this.$t('opportunities.params.referenceMode0') },
                { id: 1, label: this.$t('opportunities.params.referenceMode1') },
                { id: 2, label: this.$t('opportunities.params.referenceMode2') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Params = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormCheckbox: form_vue_.KFormCheckbox,
                BCard: external_bootstrap_vue_.BCard, BTableSimple: external_bootstrap_vue_.BTableSimple, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup
            }
        })
    ], Params);
    return Params;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var Paramsvue_type_script_lang_ts_external = (Params);

;// ./src/components/Params/Params.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Params_Paramsvue_type_script_lang_ts_external = (Paramsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Params/Params.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Params_Paramsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Params_Params = (component.exports);

/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ NoFunnel_NoFunnel; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NoFunnel/NoFunnel.vue?vue&type=template&id=2917fe0c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card',{staticClass:"text-center font-weight-bold",attrs:{"body-class":"p-5"}},[_c('p',{staticClass:"h5"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnel.noFunnel'))+" ")]),(_vm.can('app-configuration', 1))?_c('b-button',{staticClass:"mt-4",attrs:{"variant":"primary"},on:{"click":function($event){_vm.modal = true}}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnel.create'))+" ")]):_vm._e(),_c('FormModal',{attrs:{"title":_vm.$t('opportunities.funnels.createTitle'),"size":"lg"},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('FunnelForm',{on:{"submitComplete":_vm.formSubmitted}})],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/components/FunnelForm/FunnelForm.vue + 3 modules
var FunnelForm = __webpack_require__(9435);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/NoFunnel/NoFunnel.ts?vue&type=script&lang=ts&external






var NoFunnel = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(NoFunnel, _super);
    function NoFunnel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modal = false;
        return _this;
    }
    NoFunnel.prototype.formSubmitted = function (response) {
        this.setFunnel(response.data);
    };
    NoFunnel = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FunnelForm: FunnelForm/* default */.A,
                FormModal: interface_vue_.FormModal,
                BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('opportunities', ['setFunnel'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], NoFunnel);
    return NoFunnel;
}(lib/* Vue */.lD));
/* harmony default export */ var NoFunnelvue_type_script_lang_ts_external = (NoFunnel);

;// ./src/components/NoFunnel/NoFunnel.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var NoFunnel_NoFunnelvue_type_script_lang_ts_external = (NoFunnelvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/NoFunnel/NoFunnel.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  NoFunnel_NoFunnelvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NoFunnel_NoFunnel = (component.exports);

/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 1273:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FunnelViews_OpportunityView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FunnelViews/OpportunityView.vue?vue&type=template&id=71c1f881
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"opportunity-element small"},[(_vm.loading)?_c('Spinner'):[(_vm.opportunity.title)?_c('b-button',{staticClass:"p-0 mb-2 title",attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } })}}},[_vm._v(" "+_vm._s(_vm.opportunity.title)+" ")]):_vm._e(),(_vm.opportunity.category)?_c('div',[_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } })}}},[(_vm.opportunity.category.color !== '#ffffff')?_c('p',{staticClass:"category-color",style:({ 'background-color': _vm.opportunity.category.color })}):_vm._e(),_vm._v(" "+_vm._s(_vm.opportunity.category.label)+" ")])],1):_vm._e(),_c('div',{staticClass:"line"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'building']}}),(_vm.opportunity.customer)?_c('CustomerSpeedItem',{attrs:{"link":{ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } }},model:{value:(_vm.opportunity.customer),callback:function ($$v) {_vm.$set(_vm.opportunity, "customer", $$v)},expression:"opportunity.customer"}}):_vm._e()],1),(_vm.opportunity.contact)?_c('div',{staticClass:"line"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'user']}}),(_vm.opportunity.contact)?_c('ContactSpeedItem',{attrs:{"link":{ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } }},model:{value:(_vm.opportunity.contact),callback:function ($$v) {_vm.$set(_vm.opportunity, "contact", $$v)},expression:"opportunity.contact"}}):_vm._e()],1):_vm._e(),(_vm.opportunity.amount > 0)?_c('div',{staticClass:"line"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'euro-sign']}}),_c('div',[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.opportunity.amount))+" ")])],1):_vm._e(),(_vm.opportunity.probability > 0)?_c('div',{staticClass:"line"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'percentage']}}),_c('div',[_vm._v(" "+_vm._s(_vm.showNumber(_vm.opportunity.probability))+" % ")])],1):_vm._e(),_c('b-row',{staticClass:"mt-3 mb-2"},[(_vm.expireAt !== null)?_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.expireTitle }),expression:"{ title: expireTitle }"}],class:{
            'key-indicator': true,
            'inactive': _vm.expireAt === null,
            'bad': _vm.expireAt?.isSameOrBefore(),
            'good': _vm.expireAt?.isAfter(),
          },attrs:{"icon":['fas', 'clock']},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } })}}})],1):_vm._e(),_c('b-col',{staticClass:"pr-0"},[_c('b-badge',{class:{
            'status-indicator': true,
            'bad': _vm.opportunity.status === 3 || _vm.opportunity.status === 4,
            'good': _vm.opportunity.status === 2,
          },attrs:{"variant":"tag"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } })}}},[_vm._v(" "+_vm._s(_vm.opportunity.status_label)+" ")])],1),(_vm.opportunity.nextTask)?_c('b-col',{staticClass:"pr-0",attrs:{"cols":"auto"}},[_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.$t('opportunities.funnel.nextTask', { title: _vm.opportunity.nextTask.title })),expression:"$t('opportunities.funnel.nextTask', { title: opportunity.nextTask.title })"}],class:{
            'task-indicator': true,
            late: _vm.moment(_vm.opportunity.nextTask.datetime).isBefore(_vm.moment().day())
          },attrs:{"variant":"tag"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } })}}},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":['fas', 'alarm-exclamation']}}),_vm._v(" "+_vm._s(_vm.date(_vm.opportunity.nextTask.datetime))+" ")],1)],1):_vm._e(),_c('b-col',{attrs:{"cols":"auto"}},[(_vm.opportunity.team_user)?_c('b-avatar',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.opportunity.team_user.fullname }),expression:"{ title: opportunity.team_user.fullname }"}],attrs:{"size":"1.5rem","text":_vm.opportunity.team_user.initials,"src":_vm.opportunity.team_user.avatar && _vm.opportunity.team_user.avatar.file ? 'data:image.png;base64,' + _vm.opportunity.team_user.avatar.file : null}}):_vm._e()],1)],1),_c('div',{staticClass:"actions"},[_c('b-row',[_c('b-col',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();_vm.$router.push({ name: 'opportunity-item', params: { id: String(_vm.opportunity.id) } })}}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnel.see'))+" ")]),_vm._v(" | "),_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();return _vm.editOpportunity.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")])],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-dropdown',{attrs:{"variant":"link"}},[(_vm.hasModule('task') && _vm.can('task', 1))?_c('b-dropdown-item',{on:{"click":function($event){$event.preventDefault();return _vm.newTask.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('tasks.label'))+" ")]):_vm._e(),(_vm.can('send-mail', 1))?_c('SendEmailButton',{attrs:{"element":"dropdown","contact":_vm.opportunity.contact}}):_vm._e(),(_vm.hasModule('communication-reports') && _vm.can('communication-reports', 1))?_c('ReportFormButton',{attrs:{"element":"dropdown","label":_vm.$t('agregateDatas.report'),"contact":_vm.opportunity.contact,"linkedElements":_vm.linkedElements}}):_vm._e(),(_vm.hasModule('communication-letters') && _vm.can('communication-letters', 1))?_c('LetterFormButton',{attrs:{"element":"dropdown","label":_vm.$t('agregateDatas.letter'),"contact":_vm.opportunity.contact,"linkedElements":_vm.linkedElements}}):_vm._e(),(_vm.hasModule('calendar') && _vm.can('calendar', 1))?_c('CalendarButton',{attrs:{"element":"dropdown","label":_vm.$t('agregateDatas.appointment'),"linkedElements":_vm.linkedElements}}):_vm._e()],1)],1)],1)],1)],_c('OpportuntyLostForm',{attrs:{"value":_vm.opportunity},on:{"input":val => _vm.$emit('input', val)}})],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// external "moment"
var external_moment_namespaceObject = require("moment");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_namespaceObject);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(3055);
// EXTERNAL MODULE: external "@kwixeo/calendars-vue"
var calendars_vue_ = __webpack_require__(9792);
// EXTERNAL MODULE: ./src/components/OpportuntyLostForm/OpportuntyLostForm.vue + 3 modules
var OpportuntyLostForm = __webpack_require__(6212);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FunnelViews/OpportunityView.ts?vue&type=script&lang=ts&external











var OpportunityView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityView, _super);
    function OpportunityView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.expireAt = null;
        return _this;
    }
    Object.defineProperty(OpportunityView.prototype, "expireTitle", {
        get: function () {
            if (this.expireAt === null) {
                return this.$t('opportunities.funnel.noDeadline');
            }
            var date = this.date(this.opportunity.expire_at);
            if (this.expireAt.isAfter()) {
                return this.$t('opportunities.funnel.deadlineAt', { date: date });
            }
            else {
                return this.$t('opportunities.funnel.deadlinePassedSince', { date: date });
            }
        },
        enumerable: false,
        configurable: true
    });
    OpportunityView.prototype.watchOpportunity = function (opportunity) {
        this.expireAt = opportunity.expire_at ? external_moment_default()(opportunity.expire_at) : null;
    };
    OpportunityView.prototype.editOpportunity = function () {
        var _this = this;
        this.openModal({
            key: 'opportunity-form',
            value: this.opportunity,
            submitted: function (response) {
                _this.$emit('input', response.data);
            }
        });
    };
    // Create a new task
    OpportunityView.prototype.newTask = function () {
        var _this = this;
        this.openModal({
            key: 'task-form',
            value: {
                elements: this.linkedElements
            },
            submitted: function (response) {
                var task = response.data;
                if (!_this.opportunity.nextTask || external_moment_default()(task.datetime).isBefore(_this.opportunity.nextTask.datetime)) {
                    var opportunity = JSON.parse(JSON.stringify(_this.opportunity));
                    opportunity.nextTask = task;
                    _this.$emit('input', opportunity);
                }
            }
        });
    };
    Object.defineProperty(OpportunityView.prototype, "linkedElements", {
        get: function () {
            return [{
                    title: this.opportunity.reference,
                    type: 'opportunity',
                    id: this.opportunity.id,
                    data: this.opportunity
                }];
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], OpportunityView.prototype, "opportunity", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('opportunity', { immediate: true })
    ], OpportunityView.prototype, "watchOpportunity", null);
    OpportunityView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), { moment: (external_moment_default()) }),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem, ContactSpeedItem: customers_vue_.ContactSpeedItem,
                BButton: external_bootstrap_vue_.BButton, BBadge: external_bootstrap_vue_.BBadge, BFormRow: external_bootstrap_vue_.BFormRow, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAvatar: external_bootstrap_vue_.BAvatar, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownItem: external_bootstrap_vue_.BDropdownItem,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner,
                SendEmailButton: communication_vue_.SendEmailButton, ReportFormButton: communication_vue_.ReportFormButton, LetterFormButton: communication_vue_.LetterFormButton,
                CalendarButton: calendars_vue_.CalendarButton,
                OpportuntyLostForm: OpportuntyLostForm/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], OpportunityView);
    return OpportunityView;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var OpportunityViewvue_type_script_lang_ts_external = (OpportunityView);

;// ./src/components/FunnelViews/OpportunityView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FunnelViews_OpportunityViewvue_type_script_lang_ts_external = (OpportunityViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/FunnelViews/OpportunityView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FunnelViews_OpportunityViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FunnelViews_OpportunityView = (component.exports);

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FunnelList_FunnelList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FunnelList/FunnelList.vue?vue&type=template&id=01891e43
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/opportunity/funnel","datas":{ include: 'categories,steps,team_users' },"createTitle":_vm.$t('opportunities.funnels.createTitle'),"updateTitle":_vm.$t('opportunities.funnels.updateTitle'),"deleteMsg":_vm.$t('opportunities.funnels.deleteMsg'),"deleteAlertMessage":_vm.$t('opportunities.funnels.deleteAlertMessage'),"columns":_vm.columns,"customForm":_vm.customForm,"modalSize":"lg"},on:{"submitted":_vm.setFunnel,"deleted":_vm.deleteFunnel}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/FunnelForm/FunnelForm.vue + 3 modules
var FunnelForm = __webpack_require__(9435);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FunnelList/FunnelList.ts?vue&type=script&lang=ts&external





var FunnelList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FunnelList, _super);
    function FunnelList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customForm = FunnelForm/* default */.A;
        return _this;
    }
    Object.defineProperty(FunnelList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('opportunities.funnels.name'),
                    key: 'name'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    FunnelList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('opportunities', ['setFunnel', 'deleteFunnel'])),
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], FunnelList);
    return FunnelList;
}(lib/* Vue */.lD));
/* harmony default export */ var FunnelListvue_type_script_lang_ts_external = (FunnelList);

;// ./src/components/FunnelList/FunnelList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FunnelList_FunnelListvue_type_script_lang_ts_external = (FunnelListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/FunnelList/FunnelList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FunnelList_FunnelListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FunnelList_FunnelList = (component.exports);

/***/ }),

/***/ 1848:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faFolders.js
var faFolders = __webpack_require__(6737);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTimes.js
var faTimes = __webpack_require__(2986);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlusCircle.js
var faPlusCircle = __webpack_require__(6598);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faClock.js
var faClock = __webpack_require__(5474);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPencil.js
var faPencil = __webpack_require__(4831);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faBuilding.js
var faBuilding = __webpack_require__(3530);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUser.js
var faUser = __webpack_require__(2249);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faEuroSign.js
var faEuroSign = __webpack_require__(4326);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPercentage.js
var faPercentage = __webpack_require__(3098);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faAlarmExclamation.js
var faAlarmExclamation = __webpack_require__(2012);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/faArrowsAltV.js
var faArrowsAltV = __webpack_require__(7430);
;// ./src/fontawesome.ts












fontawesome_svg_core_namespaceObject.library.add(faFolders/* faFolders */.$B, faTimes/* faTimes */.GR, faPlusCircle/* faPlusCircle */.OQ, faClock/* faClock */.a$, faPencil/* faPencil */.zL, faBuilding/* faBuilding */.UR, faUser/* faUser */.X4, faEuroSign/* faEuroSign */.s5, faPercentage/* faPercentage */.WK, faAlarmExclamation/* faAlarmExclamation */.yF, faArrowsAltV/* faArrowsAltV */.zh);


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 2012:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'alarm-exclamation';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f843';
var svgPathData = 'M96 0A96 96 0 0 0 0 96a94.81 94.81 0 0 0 15.3 51.26L161.2 25.68A95.63 95.63 0 0 0 96 0zm320 0a95.66 95.66 0 0 0-65.18 25.66l145.89 121.57A94.85 94.85 0 0 0 512 96a96 96 0 0 0-96-96zM256 64C132.3 64 32 164.29 32 288a222.7 222.7 0 0 0 44.79 134l-40.1 40.09a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0L122 467.22a222.82 222.82 0 0 0 268 0l40.1 40.09a16 16 0 0 0 22.62 0l22.63-22.62a16 16 0 0 0 0-22.63L435.25 422A222.69 222.69 0 0 0 480 288c0-123.71-100.26-224-224-224zm0 352a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm25.4-110.4a16 16 0 0 1-15.9 14.4h-19a16 16 0 0 1-15.9-14.4l-12.8-128a16.06 16.06 0 0 1 15.9-17.6h44.6a16 16 0 0 1 15.9 17.6z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.yF = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'user';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f007';
var svgPathData = 'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.X4 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 2765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ OpportunityItem_OpportunityItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OpportunityItem/OpportunityItem.vue?vue&type=template&id=c5d911ee
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{staticClass:"align-items-end",attrs:{"pageTitle":_vm.$t('opportunities.opportunities.item.pageTitle', { reference: _vm.value.reference }) + (_vm.value.title ? ' - ' + _vm.value.title : ''),"buttons":_vm.headerButtons}},[_c('b-col',{staticClass:"mt-2",attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('opportunities.opportunities.item.status')}},[_c('k-form-select',{staticStyle:{"min-width":"120px"},attrs:{"options":_vm.status,"reduce":opt => opt.value,"clearable":false,"size":"sm"},on:{"input":_vm.saveForm},model:{value:(_vm.statusValue),callback:function ($$v) {_vm.statusValue=$$v},expression:"statusValue"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label":_vm.$t('opportunities.opportunities.item.step')}},[_c('k-form-select',{staticStyle:{"min-width":"120px"},attrs:{"options":_vm.funnelStep(_vm.value.funnel.id),"label":"name","clearable":false,"size":"sm"},on:{"input":_vm.saveForm},model:{value:(_vm.stepValue),callback:function ($$v) {_vm.stepValue=$$v},expression:"stepValue"}})],1)],1)],1)],1)],1),_c('AppMessages'),_c('b-row',{staticClass:"opportunity-elements h-100",attrs:{"align-v":"stretch"}},[_c('b-col',{attrs:{"lg":"4","xxl":"3"}},[_c('b-card',[(_vm.value.customer)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.customer')}},[_c('CustomerSpeedItem',{model:{value:(_vm.value.customer),callback:function ($$v) {_vm.$set(_vm.value, "customer", $$v)},expression:"value.customer"}})],1):_vm._e(),(_vm.value.customer_child)?_c('b-form-group',{attrs:{"label":_vm.teamConfigs.customer_group_child_name}},[_c('CustomerSpeedItem',{model:{value:(_vm.value.customer_child),callback:function ($$v) {_vm.$set(_vm.value, "customer_child", $$v)},expression:"value.customer_child"}})],1):_vm._e(),(_vm.value.contact)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.contact')}},[_c('ContactSpeedItem',{model:{value:(_vm.value.contact),callback:function ($$v) {_vm.$set(_vm.value, "contact", $$v)},expression:"value.contact"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.funnel.label')}},[_vm._v(" "+_vm._s(_vm.value.funnel.name)+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.step')}},[_vm._v(" "+_vm._s(_vm.value.step.name)+" ")]),(_vm.value.category)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.category')}},[_vm._v(" "+_vm._s(_vm.value.category.label)+" ")]):_vm._e(),(_vm.value.amount)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.amount')}},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.amount))+" ")]):_vm._e(),(_vm.value.expire_at)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.expire')}},[_vm._v(" "+_vm._s(_vm.date(_vm.value.expire_at))+" ")]):_vm._e(),(_vm.value.probability)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.probability')}},[_vm._v(" "+_vm._s(_vm.value.probability)+" % ")]):_vm._e(),(_vm.value.team_user)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.commercial')}},[_vm._v(" "+_vm._s(_vm.value.team_user.fullname)+" ")]):_vm._e(),(_vm.value.description)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.description')}},[_c('FroalaView',{attrs:{"value":_vm.value.description}})],1):_vm._e(),(_vm.value.custom_fields.length > 0 && !_vm.team.configs.custom_field_opportunity_tab)?_c('CustomFieldsDisplay',{staticClass:"mb-5",attrs:{"type":"opportunity","value":_vm.value.custom_fields,"titleClass":"form-title-alt"}}):_vm._e(),(_vm.value.winned_at)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.winnedAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.winned_at))+" ")]):_vm._e(),(_vm.value.losed_at)?[_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.losedAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.losed_at))+" ")]),(_vm.value.loss_reason)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.lossReason')}},[_vm._v(" "+_vm._s(_vm.value.loss_reason?.label)+" ")]):_vm._e(),(_vm.value.loss_reason_comments)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.lossReasonComments')}},[_c('TextareaView',{attrs:{"value":_vm.value.loss_reason_comments}})],1):_vm._e()]:_vm._e(),(_vm.value.cancelled_at)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.item.canceledAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.cancelled_at))+" ")]):_vm._e()],2),_c('h3',{staticClass:"form-title-alt mb-0 mt-4"},[_vm._v(_vm._s(_vm.$t('opportunities.opportunities.item.linkedDocuments')))]),_c('b-card',[_c('AffairsList',{attrs:{"value":_vm.value},on:{"input":doc => _vm.$emit('input', doc)}})],1)],1),_c('b-col',{staticClass:"mt-lg-0 mt-4 h-100",attrs:{"lg":"8","xxl":"9"}},[_c('b-row',{staticClass:"opportunity-indicators"},[_c('b-col',[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.amountQuoted'))+" ")]),_c('b-row',[_c('b-col',{staticClass:"ca-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.ca'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.quotation_ca))+" ")])]),_c('b-col',{staticClass:"margin-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.margin'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.quotation_margin))+" ")])]),_c('b-col',{staticClass:"costs-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.costs'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.quotation_costs))+" ")])])],1)],1),_c('b-col',[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.acceptedQuotation'))+" ")]),_c('b-row',[_c('b-col',{staticClass:"ca-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.ca'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.quotation_valid_ca))+" ")])]),_c('b-col',{staticClass:"margin-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.margin'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.quotation_valid_margin))+" ")])]),_c('b-col',{staticClass:"costs-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.costs'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.quotation_valid_costs))+" ")])])],1)],1),_c('b-col',[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.amountInvoiced'))+" ")]),_c('b-row',[_c('b-col',{staticClass:"ca-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.ca'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.sales_ca))+" ")])]),_c('b-col',{staticClass:"margin-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.margin'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.sales_margin))+" ")])]),_c('b-col',{staticClass:"costs-cols",attrs:{"cols":"12","xxl":"4"}},[_c('p',{staticClass:"sub-title"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.item.costs'))+" ")]),_c('p',{staticClass:"amount"},[_vm._v(" "+_vm._s(_vm.formattedNumber(_vm.value.sales_costs))+" ")])])],1)],1)],1),(_vm.team.configs.custom_field_opportunity_tab || (_vm.can('admin-subscription', 1) && _vm.value.customer.admin_team_id))?_c('b-tabs',{staticClass:"h-100 tabs-card"},[_c('b-tab',{attrs:{"title":"Élément"}},[_c('AgregateDatas',_vm._b({},'AgregateDatas',_vm.agregateProperties,false))],1),(_vm.can('admin-subscription', 1) && _vm.value.customer.admin_team_id)?_c('b-tab',{attrs:{"title":_vm.$t('customers.item.subscription'),"lazy":""}},[_c('TeamManagement',{attrs:{"value":{ id: _vm.value.customer.admin_team_id }}})],1):_vm._e(),(_vm.team.configs.custom_field_opportunity_tab && _vm.value.custom_fields.length > 0 && _vm.team.configs.custom_field_contact_tab)?_c('CustomFieldsDisplayTab',{attrs:{"type":"opportunity","value":_vm.value.custom_fields,"formUrl":'/opportunity/' + _vm.value.id,"canUpdate":_vm.can('opportunities', 2)},on:{"input":opportunity => _vm.$emit('input', opportunity)}}):_vm._e()],1):_c('b-card',{staticClass:"h-100"},[_c('AgregateDatas',_vm._b({},'AgregateDatas',_vm.agregateProperties,false))],1)],1)],1),_c('OpportuntyLostForm',{attrs:{"value":_vm.value},on:{"input":opportunity => _vm.$emit('input', opportunity)}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/calendars-vue"
var calendars_vue_ = __webpack_require__(9792);
// EXTERNAL MODULE: external "@kwixeo/communication-vue"
var communication_vue_ = __webpack_require__(3055);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// external "@kwixeo/subscriptions-vue"
var subscriptions_vue_namespaceObject = require("@kwixeo/subscriptions-vue");
// EXTERNAL MODULE: ./src/components/AffairsList/AffairsList.vue + 3 modules
var AffairsList = __webpack_require__(2923);
// EXTERNAL MODULE: ./src/components/OpportunityDelete/OpportunityDelete.vue + 3 modules
var OpportunityDelete = __webpack_require__(3562);
// EXTERNAL MODULE: ./src/components/OpportuntyLostForm/OpportuntyLostForm.vue + 3 modules
var OpportuntyLostForm = __webpack_require__(6212);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/OpportunityItem/OpportunityItem.ts?vue&type=script&lang=ts&external














var OpportunityItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityItem, _super);
    function OpportunityItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.statusValue = null;
        _this.stepValue = null;
        return _this;
    }
    OpportunityItem.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFunnels()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityItem.prototype.watchValue = function (value) {
        this.statusValue = value.status;
        this.stepValue = value.step;
    };
    Object.defineProperty(OpportunityItem.prototype, "headerButtons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('opportunities', 2)) {
                buttons.push.apply(buttons, [
                    {
                        label: this.$t('interface.edit'),
                        click: function () {
                            _this.openModal({
                                key: 'opportunity-form',
                                value: _this.value,
                                submitted: function (response) {
                                    _this.$emit('input', response.data);
                                }
                            });
                        }
                    }
                ]);
            }
            if (this.hasModule('task') && this.can('task', 1)) {
                buttons.push({
                    label: this.$t('tasks.newBtn'),
                    click: this.newTask
                });
            }
            var relations = [];
            if (this.can('send-mail', 1)) {
                relations.push({
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        contact: this.value.contact,
                        element: 'dropdown',
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('communication-reports') && this.can('communication-reports', 1)) {
                relations.push({
                    component: communication_vue_.ReportFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: this.$t('agregateDatas.report'),
                        contact: this.value.contact,
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('communication-letters') && this.can('communication-letters', 1)) {
                relations.push({
                    component: communication_vue_.LetterFormButton,
                    attributes: {
                        element: 'dropdown',
                        label: this.$t('agregateDatas.letter'),
                        contact: this.value.contact,
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (this.hasModule('calendar') && this.can('calendar', 1)) {
                relations.push({
                    component: calendars_vue_.CalendarButton,
                    attributes: {
                        element: 'dropdown',
                        label: this.$t('agregateDatas.appointment'),
                        linkedElements: this.linkedElements
                    }
                });
            }
            if (relations.length > 1) {
                buttons.push.apply(buttons, [
                    {
                        label: this.$t('communication.relation'),
                        items: relations
                    }
                ]);
            }
            else if (this.can('send-email', 1)) {
                buttons.push({
                    component: communication_vue_.SendEmailButton,
                    attributes: {
                        contact: this.value.contact,
                        element: 'button'
                    }
                });
            }
            var actions = [];
            if (this.can('sales-quotation', 2)) {
                actions.push({
                    label: this.$t('sales.quotation.label'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newDocument('quotation')];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.hasModule('sales-commands') && this.can('sales-command', 2)) {
                actions.push({
                    label: this.$t('sales.command.label'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newDocument('command')];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.hasModule('sales-deliveries') && this.can('sales-delivery', 2)) {
                actions.push({
                    label: this.$t('sales.delivery.label'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newDocument('delivery')];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.hasModule('sales-proformas') && this.can('sales-proforma', 2)) {
                actions.push({
                    label: this.$t('sales.proforma.label'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newDocument('proforma')];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.can('sales-invoice', 2)) {
                actions.push({
                    label: this.$t('sales.invoice.label'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newDocument('invoice')];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (this.can('sales-credit', 2)) {
                actions.push({
                    label: this.$t('sales.credit.label'),
                    click: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () {
                        return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.newDocument('credit')];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                });
            }
            if (actions.length > 0) {
                buttons.push({
                    label: this.$t('opportunities.opportunities.item.new'),
                    items: actions
                });
            }
            if (this.can('opportunities', 3)) {
                buttons.push.apply(buttons, [
                    {
                        component: OpportunityDelete/* default */.A,
                        attributes: {
                            value: this.value
                        },
                        events: {
                            deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, void 0, function () { return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.$router.push({ name: 'opportunity-list' })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); }
                        }
                    }
                ]);
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    OpportunityItem.prototype.newDocument = function (type) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setPageParams({
                            customer: this.value.customer,
                            contact: this.value.contact,
                            opportunity_id: this.value.id
                        });
                        return [4 /*yield*/, this.$router.push({ name: type + '-form' })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OpportunityItem.prototype, "agregateProperties", {
        get: function () {
            return {
                type: 'opportunity',
                id: this.value.id,
                model: this.value,
                customer: this.value.customer,
                contact: this.value.contact,
                modelTitle: this.value.reference,
                url: '/opportunity/' + this.value.id + '/aggregate-datas'
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityItem.prototype, "linkedElements", {
        get: function () {
            return [{
                    title: this.value.reference,
                    type: 'opportunity',
                    id: this.value.id,
                    data: this.value
                }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityItem.prototype, "status", {
        get: function () {
            return [
                { value: 1, label: this.$t('opportunities.opportunities.status.1') },
                { value: 2, label: this.$t('opportunities.opportunities.status.2') },
                { value: 3, label: this.$t('opportunities.opportunities.status.3') },
                { value: 4, label: this.$t('opportunities.opportunities.status.4') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    // Create a new task
    OpportunityItem.prototype.newTask = function () {
        this.openModal({
            key: 'task-form',
            value: {
                elements: this.linkedElements
            }
        });
    };
    OpportunityItem.prototype.saveForm = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                this.$kwOpportunities.axios.put('/opportunity/' + this.value.id, {
                    status: this.statusValue,
                    step: (_a = this.stepValue) === null || _a === void 0 ? void 0 : _a.id
                }).then(function (response) {
                    _this.$emit('input', response.data);
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], OpportunityItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], OpportunityItem.prototype, "watchValue", null);
    OpportunityItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('opportunities', ['loadFunnels'])), (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can', 'team', 'teamConfigs'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])), (0,external_vuex_.mapGetters)('opportunities', ['funnelStep'])),
            components: {
                AffairsList: AffairsList/* default */.A,
                PageHeader: interface_vue_.PageHeader, TextareaView: interface_vue_.TextareaView, AppMessages: interface_vue_.AppMessages,
                AgregateDatas: communication_vue_.AgregateDatas,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BFormGroup: external_bootstrap_vue_.BFormGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                CustomerSpeedItem: customers_vue_.CustomerSpeedItem, ContactSpeedItem: customers_vue_.ContactSpeedItem,
                CustomFieldsDisplay: custom_fields_vue_.CustomFieldsDisplay, CustomFieldsDisplayTab: custom_fields_vue_.CustomFieldsDisplayTab,
                KFormSelect: form_vue_.KFormSelect, FroalaView: form_vue_.FroalaView,
                TeamManagement: subscriptions_vue_namespaceObject.TeamManagement,
                OpportuntyLostForm: OpportuntyLostForm/* default */.A
            }
        })
    ], OpportunityItem);
    return OpportunityItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin, interface_vue_.DateMixin)));
/* harmony default export */ var OpportunityItemvue_type_script_lang_ts_external = (OpportunityItem);

;// ./src/components/OpportunityItem/OpportunityItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OpportunityItem_OpportunityItemvue_type_script_lang_ts_external = (OpportunityItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/OpportunityItem/OpportunityItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  OpportunityItem_OpportunityItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpportunityItem_OpportunityItem = (component.exports);

/***/ }),

/***/ 2923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AffairsList_AffairsList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AffairsList/AffairsList.vue?vue&type=template&id=2402f56a
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('AffairSearch',{staticClass:"mb-2",attrs:{"value":_vm.value},on:{"input":doc => _vm.$emit('input', doc)}}),_vm._l((_vm.linkedDocuments),function(documents,i){return _c('div',{key:'affair' + i,staticClass:"border mb-2 px-2 pt-2 pb-0"},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.$t('opportunities.opportunities.removeAttach')),expression:"$t('opportunities.opportunities.removeAttach')"}],staticClass:"text-danger float-right",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();_vm.deleteAttachment = i}}}),(_vm.sameTitle(i))?_c('p',{key:'title-' + i,staticClass:"small mb-1"},[_vm._v(" "+_vm._s(documents[0].document.title)+" ")]):_vm._e(),_vm._l((documents),function(el,j){return _c('b-badge',{key:j,staticClass:"mr-2 mb-2 badge-md text-left font-weight-normal opportunity-linked-document",attrs:{"variant":"light","to":{ name: el.type + '-item', params: { id: el.document.id } }}},[_c('p',{staticClass:"font-weight-bold mb-0"},[(el.document.is_advance)?[_vm._v(" "+_vm._s(_vm.$t('sales.depositInvoice.reference', { reference: el.document.reference }))+" ")]:[_vm._v(" "+_vm._s(_vm.$t('sales.' + el.type + '.reference', { reference: el.document.reference }))+" ")]],2),(_vm.teamConfigs.opportunity_linked_document_title && !_vm.sameTitle(i))?_c('p',{staticClass:"mt-2 title mb-0"},[_vm._v(" "+_vm._s(el.document.title)+" ")]):_vm._e(),(_vm.teamConfigs.opportunity_linked_document_date_amount)?_c('p',{class:{
            'mb-0': true,
            'mt-2': true,
            'font-weight-bold': el.document.title && _vm.teamConfigs.opportunity_linked_document_title
          }},[_vm._v(" "+_vm._s(_vm.date(el.document.date))+" - "+_vm._s(_vm.formattedNumber(el.document.total_ht))+" ")]):_vm._e()])})],2)}),(_vm.deleteAttachment !== null)?_c('ConfirmModal',{attrs:{"message":_vm.$t('opportunities.opportunities.removeAttachMsg')},on:{"confirmed":_vm.processDeleteAttachment,"hidden":function($event){_vm.deleteAttachment = null}}}):_vm._e()]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/AffairSearch/AffairSearch.vue + 3 modules
var AffairSearch = __webpack_require__(6651);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AffairsList/AffairsList.ts?vue&type=script&lang=ts&external







var AffairsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairsList, _super);
    function AffairsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.deleteAttachment = null;
        return _this;
    }
    Object.defineProperty(AffairsList.prototype, "sameTitle", {
        get: function () {
            var _this = this;
            return function (key) {
                var title = _this.linkedDocuments[key][0].document.title;
                return _this.linkedDocuments[key].every(function (val) { return val.document.title === title; });
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairsList.prototype, "linkedDocuments", {
        get: function () {
            var linked = {};
            if (this.value.quotations) {
                this.value.quotations.forEach(function (quotation) {
                    if (!linked[quotation.affair_id]) {
                        linked[quotation.affair_id] = [];
                    }
                    linked[quotation.affair_id].push({
                        type: 'quotation',
                        document: quotation
                    });
                });
            }
            if (this.value.commands) {
                this.value.commands.forEach(function (command) {
                    if (!linked[command.affair_id]) {
                        linked[command.affair_id] = [];
                    }
                    linked[command.affair_id].push({
                        type: 'command',
                        document: command
                    });
                });
            }
            if (this.value.proformas) {
                this.value.proformas.forEach(function (proforma) {
                    if (!linked[proforma.affair_id]) {
                        linked[proforma.affair_id] = [];
                    }
                    linked[proforma.affair_id].push({
                        type: 'proforma',
                        document: proforma
                    });
                });
            }
            if (this.value.deliveries) {
                this.value.deliveries.forEach(function (delivery) {
                    if (!linked[delivery.affair_id]) {
                        linked[delivery.affair_id] = [];
                    }
                    linked[delivery.affair_id].push({
                        type: 'delivery',
                        document: delivery
                    });
                });
            }
            if (this.value.invoices) {
                this.value.invoices.forEach(function (invoice) {
                    var _a;
                    (_a = invoice.affairs) === null || _a === void 0 ? void 0 : _a.map(function (affair) {
                        if (!linked[affair.id]) {
                            linked[affair.id] = [];
                        }
                        linked[affair.id].push({
                            type: 'invoice',
                            document: invoice
                        });
                    });
                });
            }
            if (this.value.credits) {
                this.value.credits.forEach(function (credit) {
                    var _a;
                    (_a = credit.affairs) === null || _a === void 0 ? void 0 : _a.map(function (affair) {
                        if (!linked[affair.id]) {
                            linked[affair.id] = [];
                        }
                        linked[affair.id].push({
                            type: 'credit',
                            document: credit
                        });
                    });
                });
            }
            return linked;
        },
        enumerable: false,
        configurable: true
    });
    AffairsList.prototype.processDeleteAttachment = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                this.loading = true;
                this.$kwOpportunities.axios.put('/opportunity/' + this.value.id, {
                    remove_affairs: [this.deleteAttachment]
                })
                    .then(function (response) {
                    _this.$emit('input', response.data);
                })
                    .catch(function (error) {
                    throw new Error(error);
                })
                    .finally(function () {
                    _this.loading = false;
                    _this.deleteAttachment = null;
                });
                return [2 /*return*/];
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AffairsList.prototype, "value", void 0);
    AffairsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                AffairSearch: AffairSearch/* default */.A,
                BButton: external_bootstrap_vue_.BButton, BBadge: external_bootstrap_vue_.BBadge,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner,
                ConfirmModal: interface_vue_.ConfirmModal
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], AffairsList);
    return AffairsList;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, interface_vue_.NumberMixin)));
/* harmony default export */ var AffairsListvue_type_script_lang_ts_external = (AffairsList);

;// ./src/components/AffairsList/AffairsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AffairsList_AffairsListvue_type_script_lang_ts_external = (AffairsListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AffairsList/AffairsList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AffairsList_AffairsListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AffairsList_AffairsList = (component.exports);

/***/ }),

/***/ 2986:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'times';
var width = 352;
var height = 512;
var ligatures = [];
var unicode = 'f00d';
var svgPathData = 'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.GR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3055:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/communication-vue");

/***/ }),

/***/ 3098:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'percentage';
var width = 384;
var height = 512;
var ligatures = [];
var unicode = 'f541';
var svgPathData = 'M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.WK = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3517:
/***/ (function(module) {

"use strict";
module.exports = require("sortablejs");

/***/ }),

/***/ 3530:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'building';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f1ad';
var svgPathData = 'M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.UR = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 3562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ OpportunityDelete_OpportunityDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OpportunityDelete/OpportunityDelete.vue?vue&type=template&id=6e2c3fd4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[(_vm.element !== 'modal')?[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]:_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('p',[_vm._v(_vm._s(_vm.$t('opportunities.opportunities.deleteMsg')))])]],2)],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/OpportunityDelete/OpportunityDelete.ts?vue&type=script&lang=ts&external




var OpportunityDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityDelete, _super);
    function OpportunityDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(OpportunityDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return 'div';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    OpportunityDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    OpportunityDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    OpportunityDelete.prototype.process = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwOpportunities.axios.delete('/opportunity/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    OpportunityDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    OpportunityDelete.prototype.deleted = function () {
        interface_vue_.emitter.emit('opportunityDeleted', this.value);
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], OpportunityDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], OpportunityDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], OpportunityDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], OpportunityDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], OpportunityDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], OpportunityDelete.prototype, "watchModalState", null);
    OpportunityDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                Spinner: interface_vue_.Spinner
            }
        })
    ], OpportunityDelete);
    return OpportunityDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var OpportunityDeletevue_type_script_lang_ts_external = (OpportunityDelete);

;// ./src/components/OpportunityDelete/OpportunityDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OpportunityDelete_OpportunityDeletevue_type_script_lang_ts_external = (OpportunityDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/OpportunityDelete/OpportunityDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  OpportunityDelete_OpportunityDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpportunityDelete_OpportunityDelete = (component.exports);

/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 4074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OpportunityItemView_OpportunityItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/OpportunityItemView/OpportunityItemView.vue?vue&type=template&id=46d79628
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('OpportunityItem',{model:{value:(_vm.opportunity),callback:function ($$v) {_vm.opportunity=$$v},expression:"opportunity"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/OpportunityItem/OpportunityItem.vue + 4 modules
var OpportunityItem = __webpack_require__(2765);
// EXTERNAL MODULE: ./src/fetchDatas/opportunity.ts
var fetchDatas_opportunity = __webpack_require__(521);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/OpportunityItemView/OpportunityItemView.ts?vue&type=script&lang=ts&external






var OpportunityItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityItemView, _super);
    function OpportunityItemView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.opportunity = null;
        return _this;
    }
    OpportunityItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('app', ['pageParams'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('app', ['setPageParams'])),
            components: {
                OpportunityItem: OpportunityItem/* default */.A,
                Spinner: interface_vue_.Spinner
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var pageParams;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                pageParams = lib/* Vue */.lD.prototype.$kwCustomers.store.state.app.pageParams;
                                if (pageParams && !(0,fetchDatas_opportunity/* needFetchOpportunity */._)(pageParams)) {
                                    next(function (vm) {
                                        vm.opportunity = JSON.parse(JSON.stringify(vm.pageParams));
                                        vm.setPageParams(null);
                                        vm.loading = false;
                                    });
                                    return [2 /*return*/];
                                }
                                return [4 /*yield*/, (0,fetchDatas_opportunity/* fetchOpportunity */.iU)(to.params.id)
                                        .then(function (opportunity) {
                                        next(function (vm) {
                                            vm.opportunity = opportunity;
                                            vm.loading = false;
                                            window.document.title = vm.$t('opportunities.opportunities.item.pageTitle', { reference: opportunity.reference }) + (opportunity.title ? ' - ' + opportunity.title : '');
                                            if (vm.pageParams) {
                                                vm.setPageParams(null);
                                            }
                                        });
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var opportunity;
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!to.params.id) {
                                    next();
                                    return [2 /*return*/];
                                }
                                if (this.pageParams) {
                                    opportunity = JSON.parse(JSON.stringify(this.pageParams));
                                    this.setPageParams(null);
                                    if ((0,fetchDatas_opportunity/* needFetchOpportunity */._)(opportunity)) {
                                        this.opportunity = opportunity;
                                        next();
                                        return [2 /*return*/];
                                    }
                                }
                                this.loading = true;
                                this.opportunity = null;
                                return [4 /*yield*/, (0,fetchDatas_opportunity/* fetchOpportunity */.iU)(to.params.id)
                                        .then(function (opportunity) {
                                        _this.opportunity = opportunity;
                                        _this.loading = false;
                                        window.document.title = _this.$t('opportunities.opportunities.item.pageTitle', { reference: opportunity.reference }) + (opportunity.title ? ' - ' + opportunity.title : '');
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], OpportunityItemView);
    return OpportunityItemView;
}(lib/* Vue */.lD));
/* harmony default export */ var OpportunityItemViewvue_type_script_lang_ts_external = (OpportunityItemView);

;// ./src/views/OpportunityItemView/OpportunityItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OpportunityItemView_OpportunityItemViewvue_type_script_lang_ts_external = (OpportunityItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/OpportunityItemView/OpportunityItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  OpportunityItemView_OpportunityItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpportunityItemView_OpportunityItemView = (component.exports);

/***/ }),

/***/ 4326:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'euro-sign';
var width = 320;
var height = 512;
var ligatures = [];
var unicode = 'f153';
var svgPathData = 'M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.s5 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4696:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/custom-fields-vue");

/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'pencil';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f040';
var svgPathData = 'M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5474:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'clock';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f017';
var svgPathData = 'M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.a$ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5858:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/customers-vue");

/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ OpportuntyLostForm_OpportuntyLostForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OpportuntyLostForm/OpportuntyLostForm.vue?vue&type=template&id=6407cb8e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"cancel-title":_vm.$t('opportunities.opportunities.form.pass')},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":'/opportunity/' + _vm.opportunity.id,"method":"PUT"},on:{"submitComplete":response => _vm.$emit('input', response.data)}},[_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.lossReason')}},[_c('k-form-select',{attrs:{"name":"loss_reason","options":_vm.lossReasons,"reduce":opt => opt.id},model:{value:(_vm.opportunity.loss_reason),callback:function ($$v) {_vm.$set(_vm.opportunity, "loss_reason", $$v)},expression:"opportunity.loss_reason"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.lossComments')}},[_c('k-form-textarea',{attrs:{"name":"loss_reason_comments"},model:{value:(_vm.opportunity.loss_reason_comments),callback:function ($$v) {_vm.$set(_vm.opportunity, "loss_reason_comments", $$v)},expression:"opportunity.loss_reason_comments"}})],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/OpportuntyLostForm/OpportuntyLostForm.ts?vue&type=script&lang=ts&external







var OpportuntyLostForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportuntyLostForm, _super);
    function OpportuntyLostForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.loading = false;
        _this.opportunity = {};
        return _this;
    }
    OpportuntyLostForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadLossReasons()];
                    case 1:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportuntyLostForm.prototype.watchValue = function (newValue, oldValue) {
        var _a;
        if (newValue && newValue.status === 3 && oldValue && oldValue.status !== 3) {
            this.modalState = true;
        }
        if (this.value) {
            var opportunity = JSON.parse(JSON.stringify(this.value));
            if (!opportunity.loss_reason) {
                opportunity.loss_reason = (_a = this.lossReasons.find(function (value) { return value.use_default; })) !== null && _a !== void 0 ? _a : null;
            }
            this.opportunity = opportunity;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], OpportuntyLostForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], OpportuntyLostForm.prototype, "watchValue", null);
    OpportuntyLostForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormTextarea: form_vue_.KFormTextarea,
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('opportunities', ['loadLossReasons'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('opportunities', ['lossReasons']))
        })
    ], OpportuntyLostForm);
    return OpportuntyLostForm;
}((external_vue_default())));
/* harmony default export */ var OpportuntyLostFormvue_type_script_lang_ts_external = (OpportuntyLostForm);

;// ./src/components/OpportuntyLostForm/OpportuntyLostForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OpportuntyLostForm_OpportuntyLostFormvue_type_script_lang_ts_external = (OpportuntyLostFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/OpportuntyLostForm/OpportuntyLostForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  OpportuntyLostForm_OpportuntyLostFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpportuntyLostForm_OpportuntyLostForm = (component.exports);

/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ OpportunityList_OpportunityList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OpportunityList/OpportunityList.vue?vue&type=template&id=983e972e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-table"},[(_vm.withoutPageTitle === false)?_c('PageHeader',{attrs:{"pageTitle":_vm.$t('opportunities.opportunities.pageTitle'),"buttons":_vm.buttons}}):_vm._e(),_c('AppMessages'),(_vm.loading === true)?_c('Spinner'):(_vm.availableFunnels.length === 0)?_c('NoFunnel'):[_c('k-table',{ref:"table",attrs:{"url":"/opportunity","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowActions":_vm.rowActions,"rowLink":_vm.rowLink,"stateKey":_vm.customStateKey ? _vm.customStateKey : 'opportunities',"exportable":"opportunity","importable":"opportunity","saveMainSearch":_vm.disableMainSearchSave === false}}),(_vm.statusIndicator.length > 0)?_c('div',{staticClass:"text-center"},[_c('b-card',{staticClass:"d-inline-block small mt-2 status-indicator-explain text-left",attrs:{"body-class":"px-3 py-2"}},[_c('b-row',{attrs:{"align-v":"center"}},_vm._l((_vm.statusIndicator),function(status,i){return _c('b-col',{key:i,attrs:{"cols":"auto"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{class:'pr-0 status-indicator ' + status.class,attrs:{"cols":"auto"}}),_c('b-col',{staticClass:"pl-2",attrs:{"cols":"auto"}},[_vm._v(_vm._s(status.label))])],1)],1)}),1)],1)],1):_vm._e(),_c('OpportunityDelete',{attrs:{"element":"modal","modal":_vm.deleteOpportunity !== null},on:{"closed":function($event){_vm.deleteOpportunity = null}},model:{value:(_vm.deleteOpportunity),callback:function ($$v) {_vm.deleteOpportunity=$$v},expression:"deleteOpportunity"}})]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/components/OpportunityDelete/OpportunityDelete.vue + 3 modules
var OpportunityDelete = __webpack_require__(3562);
// EXTERNAL MODULE: ./src/components/NoFunnel/NoFunnel.vue + 3 modules
var NoFunnel = __webpack_require__(844);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/OpportunityList/OpportunityList.ts?vue&type=script&lang=ts&external









var OpportunityList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityList, _super);
    function OpportunityList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.deleteOpportunity = null;
        return _this;
    }
    OpportunityList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadFunnels()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        interface_vue_.emitter.on('opportunityCreated', this.opportunityCreated);
                        interface_vue_.emitter.on('opportunityUpdated', this.opportunityUpdated);
                        interface_vue_.emitter.on('opportunityDeleted', this.opportunityDeleted);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityList.prototype.destroyed = function () {
        interface_vue_.emitter.off('opportunityCreated', this.opportunityCreated);
        interface_vue_.emitter.off('opportunityUpdated', this.opportunityUpdated);
        interface_vue_.emitter.off('opportunityDeleted', this.opportunityDeleted);
    };
    Object.defineProperty(OpportunityList.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [
                {
                    icon: 'edit',
                    click: function (opportunity) {
                        _this.openModal({
                            key: 'opportunity-form',
                            value: opportunity
                        });
                    }
                },
                {
                    icon: 'delete',
                    click: function (opportunity) {
                        _this.deleteOpportunity = opportunity;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    OpportunityList.prototype.rowLink = function (opportunity) {
        return {
            name: 'opportunity-item',
            params: {
                id: String(opportunity.id)
            }
        };
    };
    Object.defineProperty(OpportunityList.prototype, "buttons", {
        get: function () {
            if (this.availableFunnels.length === 0) {
                return [];
            }
            return [
                {
                    label: this.$t('opportunities.opportunities.newBtn'),
                    modal: {
                        key: 'opportunity-form',
                        attributes: {
                            redirect: true
                        }
                    },
                    click: function () {
                        //
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityList.prototype, "ajaxDatas", {
        get: function () {
            var filter = {};
            if (this.customer) {
                filter.customer_or_child = this.customer.id;
            }
            if (this.contact) {
                filter.contact = this.contact.id;
            }
            return {
                include: 'step,category,funnel,teamUser,customer,customer_child,contact,customFields,loss_reason',
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'reference',
                    name: this.$t('opportunities.opportunities.list.reference'),
                    visible: false
                },
                {
                    data: 'title',
                    name: this.$t('opportunities.opportunities.list.title')
                },
                {
                    data: 'customer.name',
                    name: this.$t('opportunities.opportunities.list.customer'),
                    visible: !this.customer
                }
            ];
            if (this.hasModule('customers-group')) {
                columns.push({
                    data: 'customer_child.name',
                    name: this.teamConfigs.customer_group_child_name
                });
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'contact.fullname',
                    name: this.$t('opportunities.opportunities.list.contact'),
                    visible: !this.contact
                },
                {
                    data: 'amount',
                    name: this.$t('opportunities.opportunities.list.amount'),
                    render: 'currency'
                },
                {
                    data: 'probability',
                    name: this.$t('opportunities.opportunities.list.probability'),
                    render: 'pourcent',
                    visible: false
                },
                {
                    data: 'status_label',
                    name: this.$t('opportunities.opportunities.list.status'),
                    cssClass: function (row) {
                        var cssClass = {
                            'status-indicator': true
                        };
                        cssClass['status-opportunity-' + row.status] = true;
                        return cssClass;
                    }
                },
                {
                    data: 'expire_at',
                    name: this.$t('opportunities.opportunities.list.expireAt'),
                    render: 'date',
                    visible: !this.customer && !this.contact
                },
                {
                    data: 'category.label',
                    name: this.$t('opportunities.opportunities.list.category'),
                    visible: !this.customer && !this.contact
                },
                {
                    data: 'step.name',
                    name: this.$t('opportunities.opportunities.list.step'),
                    visible: false
                },
                {
                    data: 'funnel.name',
                    name: this.$t('opportunities.opportunities.list.funnel'),
                    visible: false,
                    sortable: false
                },
                {
                    data: 'quotation_ca',
                    name: this.$t('opportunities.opportunities.list.quotationCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'quotation_costs',
                    name: this.$t('opportunities.opportunities.list.quotationCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'quotation_margin',
                    name: this.$t('opportunities.opportunities.list.quotationMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'quotation_valid_ca',
                    name: this.$t('opportunities.opportunities.list.quotationValidCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'quotation_valid_costs',
                    name: this.$t('opportunities.opportunities.list.quotationValidCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'quotation_valid_margin',
                    name: this.$t('opportunities.opportunities.list.quotationValidMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'command_ca',
                    name: this.$t('opportunities.opportunities.list.commandCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'command_costs',
                    name: this.$t('opportunities.opportunities.list.commandCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'command_margin',
                    name: this.$t('opportunities.opportunities.list.commandMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'proforma_ca',
                    name: this.$t('opportunities.opportunities.list.proformaCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'proforma_costs',
                    name: this.$t('opportunities.opportunities.list.proformaCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'proforma_margin',
                    name: this.$t('opportunities.opportunities.list.proformaMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'delivery_ca',
                    name: this.$t('opportunities.opportunities.list.deliveryCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'delivery_costs',
                    name: this.$t('opportunities.opportunities.list.deliveryCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'delivery_margin',
                    name: this.$t('opportunities.opportunities.list.deliveryMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'invoice_ca',
                    name: this.$t('opportunities.opportunities.list.invoiceCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'invoice_costs',
                    name: this.$t('opportunities.opportunities.list.invoiceCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'invoice_margin',
                    name: this.$t('opportunities.opportunities.list.invoiceMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'credit_ca',
                    name: this.$t('opportunities.opportunities.list.creditCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'credit_costs',
                    name: this.$t('opportunities.opportunities.list.creditCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'credit_margin',
                    name: this.$t('opportunities.opportunities.list.creditMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'sales_ca',
                    name: this.$t('opportunities.opportunities.list.salesCa'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'sales_costs',
                    name: this.$t('opportunities.opportunities.list.salesCosts'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'sales_margin',
                    name: this.$t('opportunities.opportunities.list.salesMargin'),
                    visible: false,
                    render: 'currency'
                },
                {
                    data: 'team_user.fullname',
                    name: this.$t('opportunities.opportunities.list.commercial')
                },
                {
                    data: 'winned_at',
                    name: this.$t('opportunities.opportunities.list.winnedAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'losed_at',
                    name: this.$t('opportunities.opportunities.list.losedAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'cancelled_at',
                    name: this.$t('opportunities.opportunities.list.cancelledAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'created_at',
                    name: this.$t('opportunities.opportunities.list.createdAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('opportunities.opportunities.list.updatedAt'),
                    visible: false,
                    render: 'datetime'
                },
                {
                    data: 'loss_reason.label',
                    name: this.$t('opportunities.opportunities.list.lossReason'),
                    visible: false
                },
                {
                    data: 'loss_reason_comments',
                    name: this.$t('opportunities.opportunities.list.lossReasonComments'),
                    visible: false
                }
            ], this.customFieldTableColumns('opportunity')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityList.prototype, "filters", {
        get: function () {
            // 'status', 'category',
            var filters = [];
            if (!this.customer) {
                filters.push({
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.customer'),
                    name: 'customer',
                    ajax: '/customer?sort=name',
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                });
            }
            if (this.hasModule('customers-group')) {
                filters.push({
                    type: 'select',
                    label: this.teamConfigs.customer_group_child_name,
                    name: 'customer_child',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1&filter[isParent]=0',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (!this.contact) {
                filters.push({
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.contact'),
                    name: 'contact',
                    ajax: '/customer/contact?sort=fullname',
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([{
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.funnel'),
                    name: 'funnel',
                    options: this.availableFunnels,
                    multiple: true,
                    optionLabel: 'name',
                    value: 'id'
                }, {
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.step'),
                    name: 'step',
                    options: this.steps,
                    params: {
                        selectable: function (opt) { return !opt.disable; }
                    },
                    multiple: true,
                    optionLabel: 'name',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.category'),
                    name: 'category',
                    options: this.allCategories,
                    params: {
                        selectable: function (opt) { return !opt.disable; }
                    },
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                }, {
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.status'),
                    name: 'status',
                    options: [
                        { value: 1, label: 'En cours' },
                        { value: 2, label: 'Gagnée' },
                        { value: 3, label: 'Perdue' },
                        { value: 4, label: 'Annulée' }
                    ],
                    multiple: true,
                    optionLabel: 'label',
                    value: 'value'
                },
                {
                    type: 'select',
                    label: this.$t('opportunities.opportunities.list.commercial'),
                    name: 'team_user',
                    options: this.teamUsers,
                    multiple: true,
                    optionLabel: 'fullname',
                    value: 'id'
                },
                {
                    type: 'period',
                    label: this.$t('opportunities.opportunities.list.expireAt'),
                    name: 'expire_since',
                    name2: 'expire_until'
                },
                {
                    type: 'period',
                    label: this.$t('interface.list.createdAt'),
                    name: 'created_since',
                    name2: 'created_until'
                }], this.customFieldTableFilters('opportunity')));
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityList.prototype, "statusIndicator", {
        get: function () {
            return [
                { class: 'status-opportunity-1', label: this.$t('opportunities.opportunities.status.1') },
                { class: 'status-opportunity-2', label: this.$t('opportunities.opportunities.status.2') },
                { class: 'status-opportunity-3', label: this.$t('opportunities.opportunities.status.3') },
                { class: 'status-opportunity-4', label: this.$t('opportunities.opportunities.status.4') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    OpportunityList.prototype.opportunityCreated = function (opportunity) {
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (data) { return data.id === opportunity.id; });
        if (index >= 0) {
            table.updateRow(index, opportunity);
        }
        else {
            table.addRow(opportunity);
        }
    };
    OpportunityList.prototype.opportunityUpdated = function (event) {
        this.opportunityCreated(event.new);
    };
    OpportunityList.prototype.opportunityDeleted = function (opportunity) {
        var table = this.$refs.table;
        var datas = table.getDatas();
        var index = datas.findIndex(function (data) { return data.id === opportunity.id; });
        if (index >= 0) {
            table.deleteRow(index);
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityList.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityList.prototype, "contact", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], OpportunityList.prototype, "withoutPageTitle", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityList.prototype, "customStateKey", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], OpportunityList.prototype, "disableMainSearchSave", void 0);
    OpportunityList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])), (0,external_vuex_.mapActions)('opportunities', ['loadFunnels'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('globalDatas', ['teamUsers'])), (0,external_vuex_.mapGetters)('user', ['can', 'teamConfigs'])), (0,external_vuex_.mapGetters)('opportunities', ['steps', 'allCategories', 'availableFunnels'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            components: {
                PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                KTable: table_vue_.KTable,
                OpportunityDelete: OpportunityDelete/* default */.A,
                NoFunnel: NoFunnel/* default */.A,
                Spinner: interface_vue_.Spinner,
                BCard: external_bootstrap_vue_.BCard, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol
            }
        })
    ], OpportunityList);
    return OpportunityList;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin)));
/* harmony default export */ var OpportunityListvue_type_script_lang_ts_external = (OpportunityList);

;// ./src/components/OpportunityList/OpportunityList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OpportunityList_OpportunityListvue_type_script_lang_ts_external = (OpportunityListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/OpportunityList/OpportunityList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  OpportunityList_OpportunityListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpportunityList_OpportunityList = (component.exports);

/***/ }),

/***/ 6598:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f055';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FunnelViews_FunnelViews; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FunnelViews/FunnelViews.vue?vue&type=template&id=d1f53a44
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100 d-flex flex-column"},[_c('div',{staticClass:"row app-title app-title-funnels pb-2"},[_c('div',{staticClass:"col align-middle"},[(_vm.availableFunnels.length <= 1)?_c('h1',{staticClass:"mb-0"},[(_vm.availableFunnels.length === 0)?[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnel.label'))+" ")]:[_vm._v(" "+_vm._s(_vm.availableFunnels[0].name)+" ")]],2):_c('k-form-select',{attrs:{"options":_vm.availableFunnels,"label":"name","clearable":false},model:{value:(_vm.selectedFunnel),callback:function ($$v) {_vm.selectedFunnel=$$v},expression:"selectedFunnel"}})],1),(_vm.can('app-configuration', 1))?_c('div',{staticClass:"col col-auto"},[_c('b-button',{attrs:{"size":"sm","to":{ name: 'opportunities-funnels' }}},[_vm._v(" "+_vm._s(_vm.$t('interface.configuration'))+" ")])],1):_vm._e()]),_c('AppMessages'),_c('div',{staticClass:"funnel-views"},[(_vm.loading)?_c('Spinner'):(_vm.availableFunnels.length === 0)?_c('NoFunnel'):[_c(_vm.isResponsive ? 'b-dropdown': 'div',{tag:"component",staticClass:"funnel-views-filters",scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('opportunities.funnel.filters'))+" "),(_vm.nbActiveFilters > 0)?_c('b-badge',{staticClass:"ml-2 badge-md rounded",attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(_vm.nbActiveFilters)+" ")]):_vm._e()]},proxy:true}])},[_c(_vm.isResponsive ? 'b-dropdown-form': 'div',{tag:"component"},[_c('b-row',{staticClass:"mt-1 funnel-filters"},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticStyle:{"min-width":"200px"},attrs:{"label":_vm.$t('opportunities.funnel.commercials'),"label-size":"sm"}},[_c('TeamUserSelect',{attrs:{"size":"sm","multiple":"","placeholder":_vm.$t('opportunities.funnel.allCommercials'),"reduce":opt => opt.id},model:{value:(_vm.teamUsers),callback:function ($$v) {_vm.teamUsers=$$v},expression:"teamUsers"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticStyle:{"min-width":"200px"},attrs:{"label":_vm.$t('opportunities.funnel.categories'),"label-size":"sm"}},[_c('k-form-select',{attrs:{"size":"sm","multiple":"","options":_vm.categories(this.selectedFunnel.id),"placeholder":_vm.$t('opportunities.funnel.allCategories'),"reduce":opt => opt.id},model:{value:(_vm.selectedCategories),callback:function ($$v) {_vm.selectedCategories=$$v},expression:"selectedCategories"}})],1)],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticStyle:{"min-width":"200px"},attrs:{"label":_vm.$t('opportunities.funnel.status'),"label-size":"sm"}},[_c('k-form-select',{attrs:{"size":"sm","multiple":"","options":_vm.status,"placeholder":_vm.$t('opportunities.funnel.allStatus'),"reduce":opt => opt.value},model:{value:(_vm.selectedStatus),callback:function ($$v) {_vm.selectedStatus=$$v},expression:"selectedStatus"}})],1)],1),_c('b-col',[_c('b-form-group',{staticClass:"small",attrs:{"label":_vm.$t('opportunities.funnel.deadline'),"label-size":"sm"}},[_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"size":"sm","max":_vm.end},model:{value:(_vm.begin),callback:function ($$v) {_vm.begin=$$v},expression:"begin"}}),_vm._v(" au "),_c('k-form-datepicker',{staticClass:"d-inline-block",attrs:{"size":"sm","min":_vm.begin},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)],1)],1)],1)],1),_c('b-row',{staticClass:"funnels-columns mx-1 mx-md-0"},_vm._l((_vm.selectedFunnel.steps),function(step){return _c('FunnelView',{key:step.id,attrs:{"funnel":_vm.selectedFunnel,"step":step,"filters":_vm.filters}})}),1)]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/FunnelViews/FunnelView.vue + 3 modules
var FunnelView = __webpack_require__(8382);
// EXTERNAL MODULE: ./src/components/NoFunnel/NoFunnel.vue + 3 modules
var NoFunnel = __webpack_require__(844);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FunnelViews/FunnelViews.ts?vue&type=script&lang=ts&external








var FunnelViews = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FunnelViews, _super);
    function FunnelViews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localStorageKey = 'funnels-view';
        _this.begin = null;
        _this.end = null;
        _this.selectedStatus = [];
        _this.selectedCategories = [];
        _this.teamUsers = [];
        _this.loading = true;
        _this.selectedFunnel = null;
        _this.modalFunnelForm = false;
        return _this;
    }
    Object.defineProperty(FunnelViews.prototype, "status", {
        get: function () {
            return [
                { value: 1, label: this.$t('opportunities.opportunities.status.1') },
                { value: 2, label: this.$t('opportunities.opportunities.status.2') },
                { value: 3, label: this.$t('opportunities.opportunities.status.3') },
                { value: 4, label: this.$t('opportunities.opportunities.status.4') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FunnelViews.prototype, "nbActiveFilters", {
        get: function () {
            var number = 0;
            if (this.begin || this.end) {
                number++;
            }
            if (this.selectedStatus.length > 0) {
                number++;
            }
            if (this.selectedCategories.length > 0) {
                number++;
            }
            if (this.teamUsers.length > 0) {
                number++;
            }
            return number;
        },
        enumerable: false,
        configurable: true
    });
    FunnelViews.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadFunnels()];
                    case 1:
                        _a.sent();
                        if (this.availableFunnels.length > 0) {
                            this.selectedFunnel = this.availableFunnels[0];
                        }
                        this.fetchParams();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(FunnelViews.prototype, "isResponsive", {
        get: function () {
            return this.windowWidth < 850;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FunnelViews.prototype, "filters", {
        get: function () {
            var filters = {};
            if (this.begin) {
                filters.expire_since = this.begin;
            }
            if (this.end) {
                filters.expire_until = this.end;
            }
            if (this.selectedStatus.length > 0) {
                filters.status = this.selectedStatus;
            }
            if (this.selectedCategories.length > 0) {
                filters.category = this.selectedCategories;
            }
            if (this.teamUsers.length > 0) {
                filters.team_user = this.teamUsers;
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    FunnelViews.prototype.watchAvailableFunnels = function (funnels, old) {
        if (old.length === 0 && funnels.length > 0) {
            this.selectedFunnel = funnels[0];
        }
    };
    FunnelViews.prototype.watchFilters = function () {
        if (!this.loading) {
            this.saveParams();
        }
    };
    FunnelViews.prototype.saveParams = function () {
        var _a;
        var params = {
            funnel: (_a = this.selectedFunnel) === null || _a === void 0 ? void 0 : _a.id,
            filters: this.filters
        };
        window.localStorage.setItem(this.localStorageKey, JSON.stringify(params));
    };
    FunnelViews.prototype.fetchParams = function () {
        var _a, _b;
        var datas = window.localStorage.getItem(this.localStorageKey);
        if (!datas) {
            return;
        }
        var json = JSON.parse(datas);
        if (json.funnel) {
            var funnel = (_a = this.availableFunnels.find(function (funnel) { return funnel.id === json.funnel; })) !== null && _a !== void 0 ? _a : null;
            if (funnel) {
                this.selectedFunnel = funnel;
            }
        }
        var filters = (_b = json.filters) !== null && _b !== void 0 ? _b : {};
        if (filters.expire_since) {
            this.begin = filters.expire_since;
        }
        if (filters.expire_until) {
            this.end = filters.expire_until;
        }
        if (filters.status) {
            this.selectedStatus = filters.status;
        }
        if (filters.category) {
            this.selectedCategories = filters.category;
        }
        if (filters.team_user) {
            this.teamUsers = filters.team_user;
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('availableFunnels')
    ], FunnelViews.prototype, "watchAvailableFunnels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('filters', { deep: true }),
        (0,lib/* Watch */.ox)('selectedFunnel')
    ], FunnelViews.prototype, "watchFilters", null);
    FunnelViews = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormSelect: form_vue_.KFormSelect, KFormDatepicker: form_vue_.KFormDatepicker,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BDropdown: external_bootstrap_vue_.BDropdown, BDropdownForm: external_bootstrap_vue_.BDropdownForm, BBadge: external_bootstrap_vue_.BBadge,
                Spinner: interface_vue_.Spinner, TeamUserSelect: interface_vue_.TeamUserSelect, AppMessages: interface_vue_.AppMessages,
                FunnelView: FunnelView/* default */.A,
                NoFunnel: NoFunnel/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('opportunities', ['loadFunnels'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('opportunities', ['availableFunnels', 'categories'])), (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapState)('app', ['windowWidth']))
        })
    ], FunnelViews);
    return FunnelViews;
}(lib/* Vue */.lD));
/* harmony default export */ var FunnelViewsvue_type_script_lang_ts_external = (FunnelViews);

;// ./src/components/FunnelViews/FunnelViews.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FunnelViews_FunnelViewsvue_type_script_lang_ts_external = (FunnelViewsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/FunnelViews/FunnelViews.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FunnelViews_FunnelViewsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FunnelViews_FunnelViews = (component.exports);

/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 6651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AffairSearch_AffairSearch; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AffairSearch/AffairSearch.vue?vue&type=template&id=b5d880b4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.close'),"ok-only":"","size":"xl"},on:{"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[(_vm.teamConfigs.opportunity_select_all_customer)?_c('CustomerSelect',{attrs:{"withForm":false},on:{"input":_vm.customerUpdated},model:{value:(_vm.customer),callback:function ($$v) {_vm.customer=$$v},expression:"customer"}}):(_vm.value.customer)?_c('b-form-group',{staticClass:"form-text",attrs:{"label":_vm.$t('customers.customer.label')}},[_vm._v(" "+_vm._s(_vm.value.customer.name)+" ")]):_vm._e()],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.documentType')}},[_c('k-form-select',{attrs:{"options":_vm.documentsTypes,"reduce":opt => opt.value,"clearable":false},model:{value:(_vm.selectedType),callback:function ($$v) {_vm.selectedType=$$v},expression:"selectedType"}})],1)],1)],1),_c('b-alert',{staticClass:"mt-1 mb-4",attrs:{"show":"","variant":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.documentAttachExplain'))+" ")]),_c('k-table',{ref:"table",attrs:{"url":'/sales/' + _vm.selectedType,"ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"stateKey":"opportunities-attachments","rowActions":_vm.rowActions}})]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AffairSearch/AffairSearch.ts?vue&type=script&lang=ts&external








var AffairSearch = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AffairSearch, _super);
    function AffairSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.selectedType = 'quotation';
        _this.loadingDocuments = true;
        _this.customer = null;
        _this.documentsTypes = [
            { value: 'quotation', label: _this.$t('sales.quotation.label') },
            { value: 'command', label: _this.$t('sales.command.label') },
            { value: 'proforma', label: _this.$t('sales.proforma.label') },
            { value: 'delivery', label: _this.$t('sales.delivery.label') },
            { value: 'invoice', label: _this.$t('sales.invoice.label') },
            { value: 'credit', label: _this.$t('sales.credit.label') }
        ];
        _this.documents = [];
        return _this;
    }
    Object.defineProperty(AffairSearch.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "ajaxDatas", {
        get: function () {
            var _a;
            return {
                include: this.selectedType === 'invoice' || this.selectedType === 'credit' ? 'affairs' : '',
                filter: {
                    customer: (_a = this.customer) === null || _a === void 0 ? void 0 : _a.id,
                    exclude: this.excludeIds
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "excludeIds", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var documents = [];
            switch (this.selectedType) {
                case 'quotation':
                    documents = (_b = (_a = this.value) === null || _a === void 0 ? void 0 : _a.quotations) !== null && _b !== void 0 ? _b : [];
                    break;
                case 'command':
                    documents = (_d = (_c = this.value) === null || _c === void 0 ? void 0 : _c.commands) !== null && _d !== void 0 ? _d : [];
                    break;
                case 'proforma':
                    documents = (_f = (_e = this.value) === null || _e === void 0 ? void 0 : _e.proformas) !== null && _f !== void 0 ? _f : [];
                    break;
                case 'delivery':
                    documents = (_h = (_g = this.value) === null || _g === void 0 ? void 0 : _g.deliveries) !== null && _h !== void 0 ? _h : [];
                    break;
                case 'invoice':
                    documents = (_k = (_j = this.value) === null || _j === void 0 ? void 0 : _j.invoices) !== null && _k !== void 0 ? _k : [];
                    break;
                case 'credit':
                    documents = (_m = (_l = this.value) === null || _l === void 0 ? void 0 : _l.credits) !== null && _m !== void 0 ? _m : [];
                    break;
            }
            return documents.map(function (quotation) { return quotation.id; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "columns", {
        get: function () {
            return [
                {
                    name: this.$t('sales.form.reference.generic'),
                    data: 'reference'
                },
                {
                    name: this.$t('sales.list.date'),
                    data: 'date',
                    render: 'date'
                },
                {
                    name: this.$t('sales.list.title'),
                    data: 'title',
                    visible: false
                },
                {
                    name: this.$t('sales.list.totalHt'),
                    data: 'total_ht',
                    render: 'currency'
                },
                {
                    name: this.$t('sales.list.totalTva'),
                    data: 'total_tva',
                    render: 'currency',
                    visible: false
                },
                {
                    name: this.$t('sales.list.totalTtc'),
                    data: 'total_ttc',
                    render: 'currency',
                    visible: false
                },
                {
                    name: this.$t('sales.list.status'),
                    data: 'status_label'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "rowActions", {
        get: function () {
            var _this = this;
            return [{
                    label: this.$t('opportunities.opportunities.attach'),
                    variant: 'secondary',
                    click: function (document) {
                        var affairs = [];
                        switch (_this.selectedType) {
                            case 'invoice':
                            case 'credit':
                                affairs = document.affairs.map(function (affair) { return affair.id; });
                                break;
                            default:
                                affairs.push(document.affair_id);
                        }
                        _this.process(affairs);
                    }
                }];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AffairSearch.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('opportunities.opportunities.documentAttach');
        },
        enumerable: false,
        configurable: true
    });
    AffairSearch.prototype.watchValue = function () {
        var _a;
        this.customer = JSON.parse(JSON.stringify((_a = this.value) === null || _a === void 0 ? void 0 : _a.customer));
    };
    AffairSearch.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    AffairSearch.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    AffairSearch.prototype.watchSelectedType = function () {
        var _this = this;
        this.loading = true;
        this.$nextTick(function () { return _this.loading = false; });
    };
    AffairSearch.prototype.process = function (affairs) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwOpportunities.axios.put('/opportunity/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id), {
                                add_affairs: affairs
                            })
                                .then(function (response) {
                                _this.$emit('input', response.data);
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                _this.loading = false;
                                throw new Error(error);
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AffairSearch.prototype.closeModal = function () {
        this.modalState = false;
    };
    AffairSearch.prototype.deleted = function () {
        interface_vue_.emitter.emit('opportunityDeleted', this.value);
        this.$emit('deleted');
    };
    AffairSearch.prototype.customerUpdated = function () {
        var table = this.$refs.table;
        table.refresh();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], AffairSearch.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], AffairSearch.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AffairSearch.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'primary' })
    ], AffairSearch.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'sm' })
    ], AffairSearch.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AffairSearch.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], AffairSearch.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], AffairSearch.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], AffairSearch.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], AffairSearch.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('selectedType')
    ], AffairSearch.prototype, "watchSelectedType", null);
    AffairSearch = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal, BFormGroup: external_bootstrap_vue_.BFormGroup, BAlert: external_bootstrap_vue_.BAlert, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                Spinner: interface_vue_.Spinner,
                KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput,
                KTable: table_vue_.KTable,
                CustomerSelect: customers_vue_.CustomerSelect
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['teamConfigs']))
        })
    ], AffairSearch);
    return AffairSearch;
}(lib/* Vue */.lD));
/* harmony default export */ var AffairSearchvue_type_script_lang_ts_external = (AffairSearch);

;// ./src/components/AffairSearch/AffairSearch.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AffairSearch_AffairSearchvue_type_script_lang_ts_external = (AffairSearchvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AffairSearch/AffairSearch.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AffairSearch_AffairSearchvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AffairSearch_AffairSearch = (component.exports);

/***/ }),

/***/ 6737:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'folders';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'f660';
var svgPathData = 'M96 336V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-48H176c-44.11 0-80-35.89-80-80zM592 64H400L336 0H176c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$B = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ParamsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ParamsView.vue?vue&type=template&id=3abf4e83
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Params')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/Params/Params.vue + 3 modules
var Params = __webpack_require__(679);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ParamsView.vue?vue&type=script&lang=ts



var ParamsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ParamsView, _super);
    function ParamsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParamsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Params: Params/* default */.A
            }
        })
    ], ParamsView);
    return ParamsView;
}(lib/* Vue */.lD));
/* harmony default export */ var ParamsViewvue_type_script_lang_ts = (ParamsView);

;// ./src/views/ParamsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ParamsViewvue_type_script_lang_ts = (ParamsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/ParamsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_ParamsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ParamsView = (component.exports);

/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7430:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'far';
var iconName = 'arrows-alt-v';
var width = 256;
var height = 512;
var ligatures = [];
var unicode = 'f338';
var svgPathData = 'M227.03 388.97H156V123.03h71.03c10.691 0 16.045-12.926 8.485-20.485l-99.029-99.03c-4.686-4.686-12.284-4.686-16.971 0l-99.029 99.03c-7.56 7.56-2.206 20.485 8.485 20.485H100v265.94H28.97c-10.691 0-16.045 12.926-8.485 20.485l99.029 99.03c4.686 4.686 12.284 4.686 16.971 0l99.029-99.03c7.56-7.559 2.206-20.485-8.484-20.485z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.zh = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 8382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FunnelViews_FunnelView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FunnelViews/FunnelView.vue?vue&type=template&id=4ddcbd75
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{class:{
    'd-flex': true,
    'flex-column': true
  }},[_c('b-row',{staticClass:"funnel-title pr-1 pt-1",attrs:{"align-v":"center","no-gutters":""}},[_c('b-col',{staticClass:"text-center title font-weight-bold"},[_vm._v(" "+_vm._s(_vm.step.name)+" ")]),_c('b-col',{staticClass:"p-0 px-1 add-col",attrs:{"cols":"auto"}},[_c('font-awesome-icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.top",value:({ title: _vm.$t('opportunities.opportunities.createBtn') }),expression:"{ title: $t('opportunities.opportunities.createBtn') }",modifiers:{"top":true}}],attrs:{"icon":['fas', 'plus-circle']},on:{"click":function($event){$event.preventDefault();return _vm.newOpportunity.apply(null, arguments)}}})],1),_c('b-col',{staticClass:"text-center small pt-2",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.nbForAmount', { length: _vm.total, amount: _vm.formattedNumber(_vm.totaAmount) }))+" ")])],1),_c('div',{staticClass:"opporunities-list"},[_c('draggable',{attrs:{"group":"opporunities","sort":false},on:{"change":_vm.onChange},model:{value:(_vm.opportunities),callback:function ($$v) {_vm.opportunities=$$v},expression:"opportunities"}},_vm._l((_vm.opportunities),function(opportunity,i){return _c('OpportunityView',{key:i,ref:'opportunity-' + opportunity.id,refInFor:true,staticClass:"mb-2",attrs:{"opportunity":_vm.opportunities[i]},on:{"input":_vm.inputOpportunity}})}),1),(_vm.loading)?_c('Spinner',{attrs:{"slot":"footer"},slot:"footer"}):_vm._e()],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__(432);
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/FunnelViews/OpportunityView.vue + 4 modules
var OpportunityView = __webpack_require__(1273);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FunnelViews/FunnelView.ts?vue&type=script&lang=ts&external








var FunnelView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.page = 1;
        _this.total = 0;
        _this.totaAmount = 0;
        _this.opportunities = [];
        return _this;
    }
    FunnelView.prototype.mounted = function () {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.loadOpportunities()];
                    case 1:
                        _b.sent();
                        interface_vue_.emitter.on('opportunityCreated', this.opportunityCreated);
                        interface_vue_.emitter.on('opportunityUpdated', this.opportunityUpdated);
                        interface_vue_.emitter.on('opportunityDeleted', this.opportunityDeleted);
                        (_a = window.document.querySelector('#page')) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', this.listenScroll);
                        return [2 /*return*/];
                }
            });
        });
    };
    FunnelView.prototype.destroyed = function () {
        var _a;
        interface_vue_.emitter.off('opportunityCreated', this.opportunityCreated);
        interface_vue_.emitter.off('opportunityUpdated', this.opportunityUpdated);
        interface_vue_.emitter.off('opportunityDeleted', this.opportunityDeleted);
        (_a = window.document.querySelector('#page')) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', this.listenScroll);
    };
    Object.defineProperty(FunnelView.prototype, "autoHideFilters", {
        get: function () {
            var filters = {};
            if (this.funnel.hide_win) {
                filters.hide_win_since = this.funnel.hide_win_delay;
            }
            if (this.funnel.hide_losed) {
                filters.hide_losed_since = this.funnel.hide_losed_delay;
            }
            if (this.funnel.hide_canceled) {
                filters.hide_cancelled_since = this.funnel.hide_canceled_delay;
            }
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    FunnelView.prototype.watchFilters = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.page = 1;
                        this.opportunities = [];
                        return [4 /*yield*/, this.loadOpportunities()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FunnelView.prototype.loadOpportunities = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.$kwOpportunities.axios.get('/opportunity', {
                                params: {
                                    page: this.page,
                                    include: ['category', 'teamUser', 'customer', 'contact', 'step', 'funnel', 'customFields', 'nextTask', 'loss_reason'],
                                    filter: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({ step: this.step.id }, this.filters), this.autoHideFilters)
                                }
                            })
                                .then(function (response) {
                                var _a;
                                (_a = _this.opportunities).push.apply(_a, response.data.data);
                                _this.total = response.data.meta.total;
                                _this.totaAmount = response.data.meta.totaAmount;
                                _this.page++;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FunnelView.prototype.newOpportunity = function () {
        var _this = this;
        this.openModal({
            key: 'opportunity-form',
            value: {
                funnel: this.funnel,
                step: this.step
            },
            submitted: function (response) {
                _this.inputOpportunity(response.data);
            }
        });
    };
    FunnelView.prototype.opportunityCreated = function (opportunity) {
        this.inputOpportunity(opportunity);
    };
    FunnelView.prototype.opportunityUpdated = function (event) {
        this.inputOpportunity(event.new);
    };
    FunnelView.prototype.opportunityDeleted = function (opportunity) {
        var index = this.opportunities.findIndex(function (val) { return val.id === opportunity.id; });
        if (index >= 0) {
            lib/* Vue */.lD.delete(this.opportunities, index);
        }
    };
    FunnelView.prototype.inputOpportunity = function (opportunity) {
        var index = this.opportunities.findIndex(function (val) { return val.id === opportunity.id; });
        if (opportunity.step_id !== this.step.id) {
            if (index > 0) {
                this.opportunityDeleted(opportunity);
            }
            return;
        }
        if (index >= 0) {
            lib/* Vue */.lD.set(this.opportunities, index, opportunity);
        }
        else {
            this.opportunities.push(opportunity);
        }
    };
    FunnelView.prototype.onChange = function (evt) {
        var event = evt.added;
        if (!event) {
            return;
        }
        var opportunity = event.element;
        var component = this.$refs['opportunity-' + opportunity.id][0];
        component.loading = true;
        this.$kwOpportunities.axios.put('/opportunity/' + opportunity.id, {
            step: this.step.id
        })
            .then(function (response) {
            interface_vue_.emitter.emit('opportunityUpdated', { old: opportunity, new: response.data });
        })
            .catch(function (error) {
            throw new Error(error);
        })
            .finally(function () {
            component.loading = false;
        });
    };
    FunnelView.prototype.listenScroll = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var page, isBottom;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        page = window.document.querySelector('#page');
                        isBottom = page.scrollTop + page.offsetHeight === page.scrollHeight;
                        if (!(!this.loading && this.opportunities.length < this.total && isBottom)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadOpportunities()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FunnelView.prototype, "funnel", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], FunnelView.prototype, "step", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return ({}); } })
    ], FunnelView.prototype, "filters", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('filters', { deep: true })
    ], FunnelView.prototype, "watchFilters", null);
    FunnelView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('dynamicModals', ['openModal'])),
            components: {
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BBadge: external_bootstrap_vue_.BBadge,
                draggable: (vuedraggable_umd_default()),
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                Spinner: interface_vue_.Spinner,
                OpportunityView: OpportunityView/* default */.A
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], FunnelView);
    return FunnelView;
}((0,lib/* Mixins */.Xe)(interface_vue_.NumberMixin)));
/* harmony default export */ var FunnelViewvue_type_script_lang_ts_external = (FunnelView);

;// ./src/components/FunnelViews/FunnelView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FunnelViews_FunnelViewvue_type_script_lang_ts_external = (FunnelViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/FunnelViews/FunnelView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FunnelViews_FunnelViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FunnelViews_FunnelView = (component.exports);

/***/ }),

/***/ 8399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 9395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_FunnelListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FunnelListView.vue?vue&type=template&id=dcfed49e
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FunnelList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/FunnelList/FunnelList.vue + 3 modules
var FunnelList = __webpack_require__(1670);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/FunnelListView.vue?vue&type=script&lang=ts



var FunnelListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FunnelListView, _super);
    function FunnelListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FunnelListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                FunnelList: FunnelList/* default */.A
            }
        })
    ], FunnelListView);
    return FunnelListView;
}(lib/* Vue */.lD));
/* harmony default export */ var FunnelListViewvue_type_script_lang_ts = (FunnelListView);

;// ./src/views/FunnelListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_FunnelListViewvue_type_script_lang_ts = (FunnelListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/FunnelListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_FunnelListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_FunnelListView = (component.exports);

/***/ }),

/***/ 9435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ FunnelForm_FunnelForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FunnelForm/FunnelForm.vue?vue&type=template&id=aade81bc
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{staticClass:"funnel-form",attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":response => _vm.$emit('submitComplete', response)}},[_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.funnels.name')}},[_c('k-form-input',{attrs:{"name":"name","required":""},model:{value:(_vm.funnel.name),callback:function ($$v) {_vm.$set(_vm.funnel, "name", $$v)},expression:"funnel.name"}})],1),_c('b-tabs',{attrs:{"content-class":"pt-3"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.stepsTitle', { nb: _vm.funnel.steps.length }))+" ")]},proxy:true}])},[_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"30px"}}),_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.funnels.stepName')))]),_c('th',{staticStyle:{"width":"100px"}},[_vm._v(_vm._s(_vm.$t('opportunities.funnels.stepProbability')))]),_c('th',{staticStyle:{"width":"30px"}})])]),(_vm.funnel.steps.length === 0)?_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"4"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.noStep'))+" ")]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.addStep.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.addStep'))+" ")])],1)])]):_c('draggable',{attrs:{"list":_vm.funnel.steps,"handle":".draggable-handle","tag":"tbody"}},_vm._l((_vm.funnel.steps),function(step,i){return _c('tr',{key:i},[_c('td',{staticClass:"align-middle text-center"},[_c('font-awesome-icon',{staticClass:"draggable-handle",attrs:{"icon":['far', 'arrows-alt-v']}})],1),_c('td',[_c('k-form-input',{attrs:{"name":'steps[' + i + '][name]',"size":"sm","required":""},model:{value:(_vm.funnel.steps[i].name),callback:function ($$v) {_vm.$set(_vm.funnel.steps[i], "name", $$v)},expression:"funnel.steps[i].name"}}),(step.id)?_c('input',{attrs:{"type":"hidden","name":'steps[' + i + '][id]'},domProps:{"value":step.id}}):_vm._e(),_c('b-row',{staticClass:"mt-1",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"pr-2",attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":'steps[' + i + '][automatic_status]'},domProps:{"value":_vm.funnel.steps[i].automatic_status}}),_c('k-form-checkbox',{attrs:{"size":"sm"},model:{value:(_vm.funnel.steps[i].automatic_status),callback:function ($$v) {_vm.$set(_vm.funnel.steps[i], "automatic_status", $$v)},expression:"funnel.steps[i].automatic_status"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.automaticStatus'))+" ")])],1),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"auto"}},[_c('k-form-select',{staticClass:"status-selector",attrs:{"name":'steps[' + i + '][status]',"disabled":!step.automatic_status,"size":"sm","options":_vm.status,"clearable":false,"required":"","reduce":opt => opt.value},model:{value:(_vm.funnel.steps[i].status),callback:function ($$v) {_vm.$set(_vm.funnel.steps[i], "status", $$v)},expression:"funnel.steps[i].status"}})],1)],1)],1),_c('td',[_c('b-input-group',{attrs:{"append":"%","size":"sm"}},[_c('k-form-spinner',{attrs:{"name":'steps[' + i + '][probability]',"size":"sm","left":"","min":"0","max":"100","step":5},model:{value:(_vm.funnel.steps[i].probability),callback:function ($$v) {_vm.$set(_vm.funnel.steps[i], "probability", $$v)},expression:"funnel.steps[i].probability"}})],1)],1),_c('td',{staticClass:"align-middle text-center"},[_c('b-button',{staticClass:"p-0",attrs:{"size":"sm","variant":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.askDeleteStep(i)}}},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']}})],1)],1)])}),0)],1),(_vm.funnel.steps.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.addStep.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.addStep'))+" ")]):_vm._e()],1),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.categoriesTitle', { nb: _vm.funnel.categories.length }))+" ")]},proxy:true}])},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.categoryExplain'))+" ")]),(_vm.funnel.categories.length === 0)?_c('input',{attrs:{"type":"hidden","name":"categories"},domProps:{"value":null}}):_vm._e(),_c('table',{staticClass:"table table-sm table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.funnels.categoryName')))]),_c('th',[_vm._v(_vm._s(_vm.$t('opportunities.funnels.categoryColor')))]),_c('th',{staticStyle:{"width":"30px"}})])]),_c('tbody',[(_vm.funnel.categories.length === 0)?_c('tr',[_c('td',{staticClass:"text-center p-4",attrs:{"colspan":"3"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.noCategory'))+" ")]),_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.addCategory.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.addCategory'))+" ")])],1)]):_vm._e(),_vm._l((_vm.funnel.categories),function(categorie,i){return _c('tr',{key:i},[_c('td',[_c('k-form-input',{attrs:{"name":'categories[' + i + '][label]',"size":"sm","required":""},model:{value:(_vm.funnel.categories[i].label),callback:function ($$v) {_vm.$set(_vm.funnel.categories[i], "label", $$v)},expression:"funnel.categories[i].label"}})],1),_c('td',[_c('k-form-input',{attrs:{"type":"color","name":'categories[' + i + '][color]',"size":"sm"},model:{value:(_vm.funnel.categories[i].color),callback:function ($$v) {_vm.$set(_vm.funnel.categories[i], "color", $$v)},expression:"funnel.categories[i].color"}})],1),_c('td',{staticClass:"align-middle text-center"},[_c('font-awesome-icon',{staticClass:"text-danger",attrs:{"icon":['fas', 'times']},on:{"click":function($event){$event.preventDefault();return _vm.deleteCategory(i)}}})],1)])})],2)]),(_vm.funnel.categories.length > 0)?_c('b-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.addCategory.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.addCategory'))+" ")]):_vm._e()],1),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.restrictionsTitle'))+" "),(_vm.funnel.restricted)?[_vm._v(" ("+_vm._s(_vm.funnel.team_users.length)+") ")]:_vm._e()]},proxy:true}])},[_c('k-form-checkbox',{model:{value:(_vm.funnel.restricted),callback:function ($$v) {_vm.$set(_vm.funnel, "restricted", $$v)},expression:"funnel.restricted"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.restrict'))+" ")]),_c('input',{attrs:{"type":"hidden","name":"restricted"},domProps:{"value":_vm.funnel.restricted}}),(_vm.funnel.restricted)?[_c('b-form-group',{staticClass:"mt-3",attrs:{"label":_vm.$t('opportunities.funnels.restrictUser')}},[_c('TeamUserSelect',{attrs:{"multiple":""},model:{value:(_vm.funnel.team_users),callback:function ($$v) {_vm.$set(_vm.funnel, "team_users", $$v)},expression:"funnel.team_users"}}),(_vm.funnel.team_users)?_c('input',{attrs:{"type":"hidden","name":"team_users"},domProps:{"value":null}}):_vm._e(),_vm._l((_vm.funnel.team_users),function(user){return _c('input',{key:user.id,attrs:{"type":"hidden","name":"team_users[]"},domProps:{"value":user.id}})})],2)]:_vm._e()],2),_c('b-tab',{attrs:{"title":"Options d'affichage"}},[_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"hide_win"},domProps:{"value":_vm.funnel.hide_win}}),_c('k-form-checkbox',{model:{value:(_vm.funnel.hide_win),callback:function ($$v) {_vm.$set(_vm.funnel, "hide_win", $$v)},expression:"funnel.hide_win"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.hideWin'))+" ")])],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-spinner',{staticClass:"day-input",attrs:{"name":"hide_win_delay","size":"sm","min":0,"disabled":!_vm.funnel.hide_win},model:{value:(_vm.funnel.hide_win_delay),callback:function ($$v) {_vm.$set(_vm.funnel, "hide_win_delay", $$v)},expression:"funnel.hide_win_delay"}})],1),_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.hideDays'))+" ")])],1),_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"hide_losed"},domProps:{"value":_vm.funnel.hide_losed}}),_c('k-form-checkbox',{model:{value:(_vm.funnel.hide_losed),callback:function ($$v) {_vm.$set(_vm.funnel, "hide_losed", $$v)},expression:"funnel.hide_losed"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.hideLose'))+" ")])],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-spinner',{staticClass:"day-input",attrs:{"name":"hide_losed_delay","size":"sm","min":0,"disabled":!_vm.funnel.hide_losed},model:{value:(_vm.funnel.hide_losed_delay),callback:function ($$v) {_vm.$set(_vm.funnel, "hide_losed_delay", $$v)},expression:"funnel.hide_losed_delay"}})],1),_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.hideDays'))+" ")])],1),_c('b-row',{staticClass:"mt-2",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"hide_canceled"},domProps:{"value":_vm.funnel.hide_canceled}}),_c('k-form-checkbox',{model:{value:(_vm.funnel.hide_canceled),callback:function ($$v) {_vm.$set(_vm.funnel, "hide_canceled", $$v)},expression:"funnel.hide_canceled"}},[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.hideCancel'))+" ")])],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-spinner',{staticClass:"day-input",attrs:{"name":"hide_canceled_delay","size":"sm","min":0,"disabled":!_vm.funnel.hide_canceled},model:{value:(_vm.funnel.hide_canceled_delay),callback:function ($$v) {_vm.$set(_vm.funnel, "hide_canceled_delay", $$v)},expression:"funnel.hide_canceled_delay"}})],1),_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('opportunities.funnels.hideDays'))+" ")])],1)],1)],1),(_vm.deleteStepIndex !== null)?_c('ConfirmModal',{on:{"hidden":function($event){_vm.deleteStepIndex = null},"confirmed":function($event){return _vm.deleteStep(_vm.deleteStepIndex)}}},[_c('b-alert',{staticClass:"mb-0",attrs:{"variant":"danger","show":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('opportunities.funnels.deleteStepAlert'))}})])],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.js
var vuedraggable_umd = __webpack_require__(432);
var vuedraggable_umd_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/FunnelForm/FunnelForm.ts?vue&type=script&lang=ts&external







var FunnelForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(FunnelForm, _super);
    function FunnelForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.funnel = {
            categories: [],
            steps: [],
            restricted: false,
            team_users: [],
            hide_win: false,
            hide_win_delay: 2,
            hide_canceled: false,
            hide_canceled_delay: 2,
            hide_losed: false,
            hide_losed_delay: 2
        };
        _this.deleteStepIndex = null;
        return _this;
    }
    Object.defineProperty(FunnelForm.prototype, "status", {
        get: function () {
            return [
                { value: 1, label: this.$t('opportunities.opportunities.status.1') },
                { value: 2, label: this.$t('opportunities.opportunities.status.2') },
                { value: 3, label: this.$t('opportunities.opportunities.status.3') },
                { value: 4, label: this.$t('opportunities.opportunities.status.4') }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FunnelForm.prototype, "formAction", {
        get: function () {
            var url = '/opportunity/funnel';
            if (this.funnel.id) {
                url += '/' + this.funnel.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FunnelForm.prototype, "formMethod", {
        get: function () {
            return this.funnel.id ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    FunnelForm.prototype.watchValue = function (value) {
        if (value) {
            this.funnel = Object.assign({
                team_users: [],
                hide_win: false,
                hide_win_delay: 2,
                hide_canceled: false,
                hide_canceled_delay: 2,
                hide_losed: false,
                hide_losed_delay: 2,
            }, JSON.parse(JSON.stringify(value)));
        }
    };
    FunnelForm.prototype.addCategory = function () {
        this.funnel.categories.push({
            label: '',
            color: '#ffffff'
        });
    };
    FunnelForm.prototype.deleteCategory = function (index) {
        lib/* Vue */.lD.delete(this.funnel.categories, index);
    };
    FunnelForm.prototype.addStep = function () {
        this.funnel.steps.push({
            name: '',
            automatic_status: false,
            status: 1,
            probability: 0
        });
    };
    FunnelForm.prototype.askDeleteStep = function (index) {
        this.deleteStepIndex = index;
    };
    FunnelForm.prototype.deleteStep = function (index) {
        lib/* Vue */.lD.delete(this.funnel.steps, index);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], FunnelForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], FunnelForm.prototype, "watchValue", null);
    FunnelForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TeamUserSelect: interface_vue_.TeamUserSelect, ConfirmModal: interface_vue_.ConfirmModal,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox, KFormSelect: form_vue_.KFormSelect,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BAlert: external_bootstrap_vue_.BAlert, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon,
                draggable: (vuedraggable_umd_default())
            }
        })
    ], FunnelForm);
    return FunnelForm;
}(lib/* Vue */.lD));
/* harmony default export */ var FunnelFormvue_type_script_lang_ts_external = (FunnelForm);

;// ./src/components/FunnelForm/FunnelForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var FunnelForm_FunnelFormvue_type_script_lang_ts_external = (FunnelFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/FunnelForm/FunnelForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  FunnelForm_FunnelFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FunnelForm_FunnelForm = (component.exports);

/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Emit, Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 9792:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/calendars-vue");

/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_OpportunityListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/OpportunityListView.vue?vue&type=template&id=6d2c66c2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('OpportunityList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/OpportunityList/OpportunityList.vue + 3 modules
var OpportunityList = __webpack_require__(6507);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/OpportunityListView.vue?vue&type=script&lang=ts



var OpportunityListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityListView, _super);
    function OpportunityListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpportunityListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                OpportunityList: OpportunityList/* default */.A
            }
        })
    ], OpportunityListView);
    return OpportunityListView;
}(lib/* Vue */.lD));
/* harmony default export */ var OpportunityListViewvue_type_script_lang_ts = (OpportunityListView);

;// ./src/views/OpportunityListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_OpportunityListViewvue_type_script_lang_ts = (OpportunityListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/OpportunityListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_OpportunityListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_OpportunityListView = (component.exports);

/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "opportunities.common." + "opportunities" + ".js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@kwixeo/opportunities-vue:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			119: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_opportunities_vue"] = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_opportunities_vue"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AffairSearch: function() { return /* reexport */ AffairSearch/* default */.A; },
  AffairsList: function() { return /* reexport */ AffairsList/* default */.A; },
  FunnelForm: function() { return /* reexport */ FunnelForm/* default */.A; },
  FunnelList: function() { return /* reexport */ FunnelList/* default */.A; },
  FunnelListView: function() { return /* reexport */ FunnelListView["default"]; },
  FunnelView: function() { return /* reexport */ FunnelView/* default */.A; },
  FunnelViews: function() { return /* reexport */ FunnelViews/* default */.A; },
  FunnelsView: function() { return /* reexport */ FunnelsView["default"]; },
  KwixeoOpportunities: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang; },
  NoFunnel: function() { return /* reexport */ NoFunnel/* default */.A; },
  OpportunitiesStore: function() { return /* reexport */ modules_OpportunitiesStore; },
  OpportunityDelete: function() { return /* reexport */ OpportunityDelete/* default */.A; },
  OpportunityForm: function() { return /* reexport */ OpportunityForm_OpportunityForm; },
  OpportunityItem: function() { return /* reexport */ OpportunityItem/* default */.A; },
  OpportunityItemView: function() { return /* reexport */ OpportunityItemView["default"]; },
  OpportunityList: function() { return /* reexport */ OpportunityList/* default */.A; },
  OpportunityListView: function() { return /* reexport */ OpportunityListView["default"]; },
  OpportunityView: function() { return /* reexport */ OpportunityView/* default */.A; },
  Params: function() { return /* reexport */ Params/* default */.A; },
  ParamsView: function() { return /* reexport */ ParamsView["default"]; },
  configRoutes: function() { return /* reexport */ configRoutes; },
  fetchOpportunity: function() { return /* reexport */ opportunity/* fetchOpportunity */.iU; },
  needFetchOpportunity: function() { return /* reexport */ opportunity/* needFetchOpportunity */._; },
  opportunityRelations: function() { return /* reexport */ opportunity/* opportunityRelations */.vc; },
  routes: function() { return /* reexport */ router_routes; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/AffairSearch/AffairSearch.vue + 3 modules
var AffairSearch = __webpack_require__(6651);
// EXTERNAL MODULE: ./src/components/AffairsList/AffairsList.vue + 3 modules
var AffairsList = __webpack_require__(2923);
// EXTERNAL MODULE: ./src/components/FunnelForm/FunnelForm.vue + 3 modules
var FunnelForm = __webpack_require__(9435);
// EXTERNAL MODULE: ./src/components/FunnelList/FunnelList.vue + 3 modules
var FunnelList = __webpack_require__(1670);
// EXTERNAL MODULE: ./src/components/FunnelViews/FunnelView.vue + 3 modules
var FunnelView = __webpack_require__(8382);
// EXTERNAL MODULE: ./src/components/FunnelViews/FunnelViews.vue + 3 modules
var FunnelViews = __webpack_require__(6615);
// EXTERNAL MODULE: ./src/components/NoFunnel/NoFunnel.vue + 3 modules
var NoFunnel = __webpack_require__(844);
// EXTERNAL MODULE: ./src/components/FunnelViews/OpportunityView.vue + 4 modules
var OpportunityView = __webpack_require__(1273);
// EXTERNAL MODULE: ./src/components/OpportunityDelete/OpportunityDelete.vue + 3 modules
var OpportunityDelete = __webpack_require__(3562);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OpportunityForm/OpportunityForm.vue?vue&type=template&id=7e66b6c9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.title')}},[_c('k-form-input',{attrs:{"name":"title"},model:{value:(_vm.opportunity.title),callback:function ($$v) {_vm.$set(_vm.opportunity, "title", $$v)},expression:"opportunity.title"}})],1),_c('b-row',[_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"customer"},domProps:{"value":_vm.opportunity.customer ? _vm.opportunity.customer.id : null}}),_c('CustomerSelect',{attrs:{"validationName":"customer","required":"","include":['childs', 'parent', 'parent.childs']},model:{value:(_vm.opportunity.customer),callback:function ($$v) {_vm.$set(_vm.opportunity, "customer", $$v)},expression:"opportunity.customer"}})],1),_c('input',{attrs:{"name":"customer_child","type":"hidden"},domProps:{"value":_vm.opportunity.customer_child ? _vm.opportunity.customer_child.id : null}}),(_vm.hasModule('customers-group') && _vm.opportunity?.customer?.childs?.length > 0)?_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.teamConfigs.customer_group_child_name}},[_c('k-form-select',{attrs:{"options":_vm.opportunity.customer?.childs ?? [],"label":"name"},model:{value:(_vm.opportunity.customer_child),callback:function ($$v) {_vm.$set(_vm.opportunity, "customer_child", $$v)},expression:"opportunity.customer_child"}})],1)],1):_vm._e(),_c('b-col',[_c('input',{attrs:{"type":"hidden","name":"contact"},domProps:{"value":_vm.opportunity.contact ? _vm.opportunity.contact.id : null}}),_c('ContactSelect',{attrs:{"customer":_vm.opportunity.customer,"validationName":"contact","disabled":!_vm.opportunity.customer},model:{value:(_vm.opportunity.contact),callback:function ($$v) {_vm.$set(_vm.opportunity, "contact", $$v)},expression:"opportunity.contact"}})],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.description')}},[_c('k-form-editor',{attrs:{"size":"sm","name":"description"},model:{value:(_vm.opportunity.description),callback:function ($$v) {_vm.$set(_vm.opportunity, "description", $$v)},expression:"opportunity.description"}})],1),(_vm.availableFunnels.length > 1)?_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.funnel'),"label-cols":"3","content-cols":"auto"}},[_c('k-form-select',{staticStyle:{"min-width":"250px"},attrs:{"options":_vm.availableFunnels,"label":"name","reduce":funnel => funnel.id,"clearable":false,"required":""},on:{"input":function($event){_vm.opportunity.step = null; _vm.opportunity.category = null}},model:{value:(_vm.funnelId),callback:function ($$v) {_vm.funnelId=$$v},expression:"funnelId"}})],1):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.step'),"label-cols":"3","content-cols":"auto"}},[_c('k-form-select',{staticStyle:{"min-width":"250px"},attrs:{"options":_vm.funnelStep(_vm.funnelId ?? 0),"label":"name","clearable":false,"validationName":"step","required":"","disabled":!_vm.funnelId},on:{"input":_vm.stepSelected},model:{value:(_vm.opportunity.step),callback:function ($$v) {_vm.$set(_vm.opportunity, "step", $$v)},expression:"opportunity.step"}}),_c('input',{attrs:{"type":"hidden","name":"step"},domProps:{"value":_vm.opportunity.step ? _vm.opportunity.step.id : null}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.category'),"label-cols":"3","content-cols":"auto"}},[_c('k-form-select',{staticStyle:{"min-width":"250px"},attrs:{"options":_vm.categories(_vm.funnelId ?? 0),"validationName":"category","disabled":!_vm.funnelId},model:{value:(_vm.opportunity.category),callback:function ($$v) {_vm.$set(_vm.opportunity, "category", $$v)},expression:"opportunity.category"}}),_c('input',{attrs:{"type":"hidden","name":"category"},domProps:{"value":_vm.opportunity.category ? _vm.opportunity.category.id : null}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.amount'),"label-cols":"3","content-cols":"auto"}},[_c('b-input-group',{attrs:{"append":_vm.currency.symbol}},[_c('k-form-number',{attrs:{"name":"amount","min":0,"noDefaultValue":""},model:{value:(_vm.opportunity.amount),callback:function ($$v) {_vm.$set(_vm.opportunity, "amount", $$v)},expression:"opportunity.amount"}})],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.expire'),"label-cols":"3","content-cols":"auto"}},[_c('k-form-datepicker',{attrs:{"name":"expire_at"},model:{value:(_vm.opportunity.expire_at),callback:function ($$v) {_vm.$set(_vm.opportunity, "expire_at", $$v)},expression:"opportunity.expire_at"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.probability'),"label-cols":"3","content-cols":"auto"}},[_c('b-input-group',{attrs:{"append":"%"}},[_c('k-form-spinner',{attrs:{"name":"probability","min":0,"max":100,"noDefaultValue":"","left":""},model:{value:(_vm.opportunity.probability),callback:function ($$v) {_vm.$set(_vm.opportunity, "probability", $$v)},expression:"opportunity.probability"}})],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.commercial'),"label-cols":"3","content-cols":"auto"}},[_c('TeamUserSelect',{staticStyle:{"min-width":"250px"},attrs:{"clearable":"","selectDefault":!_vm.opportunity.id},model:{value:(_vm.opportunity.team_user),callback:function ($$v) {_vm.$set(_vm.opportunity, "team_user", $$v)},expression:"opportunity.team_user"}}),_c('input',{attrs:{"type":"hidden","name":"team_user"},domProps:{"value":_vm.opportunity.team_user?.id}})],1),_c('CustomFieldsForm',{attrs:{"type":"opportunity"},model:{value:(_vm.opportunity.custom_fields),callback:function ($$v) {_vm.$set(_vm.opportunity, "custom_fields", $$v)},expression:"opportunity.custom_fields"}}),(_vm.opportunity.status === 3)?[_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('opportunities.opportunities.form.lossTitle'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.lossReason')}},[_c('k-form-select',{attrs:{"name":"loss_reason","options":_vm.lossReasons,"reduce":opt => opt.id},model:{value:(_vm.opportunity.loss_reason),callback:function ($$v) {_vm.$set(_vm.opportunity, "loss_reason", $$v)},expression:"opportunity.loss_reason"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('opportunities.opportunities.form.lossComments')}},[_c('k-form-textarea',{attrs:{"name":"loss_reason_comments"},model:{value:(_vm.opportunity.loss_reason_comments),callback:function ($$v) {_vm.$set(_vm.opportunity, "loss_reason_comments", $$v)},expression:"opportunity.loss_reason_comments"}})],1)]:_vm._e()],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/fetchDatas/opportunity.ts
var opportunity = __webpack_require__(521);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/OpportunityForm/OpportunityForm.ts?vue&type=script&lang=ts&external









var OpportunityForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunityForm, _super);
    function OpportunityForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.opportunity = {
            customer_child: null,
            step: null,
            custom_fields: []
        };
        _this.loading = false;
        _this.funnelId = null;
        _this.initialized = true;
        return _this;
    }
    OpportunityForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadLossReasons()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadFunnels()];
                    case 2:
                        _a.sent();
                        if (this.availableFunnels.length === 1) {
                            this.funnelId = this.availableFunnels[0].id;
                        }
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(OpportunityForm.prototype, "formAction", {
        get: function () {
            var url = '/opportunity';
            if (this.opportunity.id) {
                url += '/' + this.opportunity.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunityForm.prototype, "formMethod", {
        get: function () {
            return this.opportunity.id !== undefined ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    OpportunityForm.prototype.watchValue = function (value) {
        var _a, _b;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.initialized = false;
                        if (!value) return [3 /*break*/, 3];
                        if (!value.id) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, (0,opportunity/* fetchOpportunity */.iU)(value.id)];
                    case 1:
                        value = _c.sent();
                        this.loading = false;
                        _c.label = 2;
                    case 2:
                        this.opportunity = Object.assign({
                            custom_fields: [],
                            category: null,
                            step: null,
                            customer_child: null
                        }, JSON.parse(JSON.stringify(value)));
                        this.funnelId = (_b = (_a = value.funnel) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
                        _c.label = 3;
                    case 3:
                        this.$nextTick(function () {
                            _this.initialized = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityForm.prototype.watchCustomer = function (value, old) {
        var _this = this;
        if (!this.initialized) {
            return;
        }
        if ((value === null || value === void 0 ? void 0 : value.id) !== (old === null || old === void 0 ? void 0 : old.id)) {
            this.opportunity.contact = null;
            this.opportunity.customer_child = null;
        }
        if (this.hasModule('customers-group') && this.teamConfigs.customer_group_opportunity_parent_select && value && value.parent) {
            this.opportunity.customer = value.parent;
            this.$nextTick(function () {
                _this.opportunity.customer_child = value;
            });
            return;
        }
    };
    OpportunityForm.prototype.stepSelected = function (step) {
        if (step && step.probability > 0) {
            this.opportunity.probability = step.probability;
        }
    };
    OpportunityForm.prototype.submitComplete = function (response) {
        var opportunity = response.data;
        if (this.opportunity.id) {
            interface_vue_.emitter.emit('opportunityUpdated', { old: this.value, new: opportunity });
        }
        else {
            interface_vue_.emitter.emit('opportunityCreated', opportunity);
        }
        this.$emit('input', opportunity);
        if (this.redirect) {
            this.$router.push({
                name: 'opportunity-item',
                params: {
                    id: String(opportunity.id)
                }
            });
        }
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], OpportunityForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], OpportunityForm.prototype, "redirect", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], OpportunityForm.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('opportunity.customer')
    ], OpportunityForm.prototype, "watchCustomer", null);
    OpportunityForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['currency', 'teamConfigs'])), (0,external_vuex_.mapGetters)('opportunities', ['funnelStep', 'categories', 'availableFunnels'])), (0,external_vuex_.mapState)('opportunities', ['lossReasons'])), (0,external_vuex_.mapGetters)('subscriptions', ['hasModule'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('opportunities', ['loadFunnels', 'loadLossReasons'])),
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormNumber: form_vue_.KFormNumber, KFormDatetime: form_vue_.KFormDatetime, KFormSpinner: form_vue_.KFormSpinner, KFormEditor: form_vue_.KFormEditor, KFormDatepicker: form_vue_.KFormDatepicker, KFormSelect: form_vue_.KFormSelect, KFormTextarea: form_vue_.KFormTextarea,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BInputGroup: external_bootstrap_vue_.BInputGroup,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                TeamUserSelect: interface_vue_.TeamUserSelect, Spinner: interface_vue_.Spinner,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm
            }
        })
    ], OpportunityForm);
    return OpportunityForm;
}(lib/* Vue */.lD));
/* harmony default export */ var OpportunityFormvue_type_script_lang_ts_external = (OpportunityForm);

;// ./src/components/OpportunityForm/OpportunityForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var OpportunityForm_OpportunityFormvue_type_script_lang_ts_external = (OpportunityFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/OpportunityForm/OpportunityForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  OpportunityForm_OpportunityFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpportunityForm_OpportunityForm = (component.exports);
// EXTERNAL MODULE: ./src/components/OpportunityItem/OpportunityItem.vue + 4 modules
var OpportunityItem = __webpack_require__(2765);
// EXTERNAL MODULE: ./src/components/OpportunityList/OpportunityList.vue + 3 modules
var OpportunityList = __webpack_require__(6507);
// EXTERNAL MODULE: ./src/components/Params/Params.vue + 3 modules
var Params = __webpack_require__(679);
// EXTERNAL MODULE: ./src/views/OpportunityItemView/OpportunityItemView.vue + 3 modules
var OpportunityItemView = __webpack_require__(4074);
// EXTERNAL MODULE: ./src/views/FunnelListView.vue + 3 modules
var FunnelListView = __webpack_require__(9395);
// EXTERNAL MODULE: ./src/views/FunnelsView.vue + 3 modules
var FunnelsView = __webpack_require__(445);
// EXTERNAL MODULE: ./src/views/OpportunityListView.vue + 3 modules
var OpportunityListView = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/views/ParamsView.vue + 3 modules
var ParamsView = __webpack_require__(6835);
;// ./src/lang/en.ts
var opportunitiesLang = {};
/* harmony default export */ var en = ({
    opportunities: opportunitiesLang
});

;// ./src/lang/fr.ts
var fr_opportunitiesLang = {
    params: {
        menuParent: 'Opportunités',
        menu: 'Paramètres',
        pageTitle: 'Paramètres des opportunités',
        allowAllCustomer: 'Permettre de rattacher des documents dont le client ne correspond pas à l\'opportunité',
        linkedDocumentTitle: 'Affichage des documents liés sur la fiche opportunité :',
        linkedDocumentShowTitle: 'Afficher le titre du document',
        linkedDocumentShowDateAmount: 'Afficher la date et le montant du document',
        referenceTitle: 'Numérotation des opportunités',
        referencePrefix: 'Préfixe',
        referenceNextNumber: 'Prochain numéro',
        referenceTypeNumber: 'Type de numérotation',
        referenceLength: 'Nombre de chiffre',
        referenceExplain: 'Vous pouvez utiliser le jour, le mois ou l\'année en cours dans les préfixes des numéros. Pour cela, insérez l\'une des variables ci-dessous :',
        referenceYear4: 'l\'année sur 4 chiffres',
        referenceYear2: 'l\'année sur 2 chiffres',
        referenceMonth: 'le mois',
        referenceDay: 'le jour',
        referenceMode0: 'Normal',
        referenceMode1: 'Remise à 0 tous les mois',
        referenceMode2: 'Remise à 0 tous les ans',
    },
    funnels: {
        menu: 'Tunnels de vente',
        pageTitle: 'Gestion des tunnels de vente',
        createTitle: 'Création d\'un tunnel de vente',
        updateTitle: 'Modification d\'un tunnel de vente',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce tunnel de vente ?',
        deleteAlertMessage: 'Attention, toutes les opportunités rattachées au tunnel de vente seront supprimées.',
        name: 'Nom du tunnel de vente',
        stepsTitle: 'Étapes ({nb})',
        stepName: 'Nom',
        stepProbability: 'Probabilité',
        noStep: 'Aucune étape',
        addStep: 'Ajouter une étape',
        categoriesTitle: 'Catégories ({nb})',
        categoryExplain: 'Les catégories peuvent être appliquées aux différentes opportunités du tunnel de vente.',
        categoryName: 'Nom',
        categoryColor: 'Couleur',
        noCategory: 'Aucune catégorie',
        addCategory: 'Ajouter une catégorie',
        restrictionsTitle: 'Restrictions',
        restrict: 'Restreindre l\'accès au tunnel de vente',
        restrictUser: 'Utilisateur(s) ayant accès au tunnel de vente',
        automaticStatus: 'Passer automatiquement l\'opportunité au statut',
        hideWin: 'Masquer les opportunitées gagnées au bout de',
        hideLose: 'Masquer les opportunitées perdues au bout de',
        hideCancel: 'Masquer les opportunitées annulées au bout de',
        hideDays: 'jour(s)',
        deleteStepAlert: 'Attention, la suppression de l\'étape entrainera la <strong>suppression de toutes les opportunités</strong> utilisant cette étape.'
    },
    funnel: {
        pageTitle: 'Tunnel de vente',
        menu: 'Tunnel de vente',
        label: 'Tunnel de vente',
        filters: 'Filtres',
        commercials: 'Commerciaux',
        allCommercials: 'Tous les commerciaux',
        categories: 'Catégories',
        allCategories: 'Toutes les catégories',
        status: 'Statuts',
        allStatus: 'Tous les statuts',
        deadline: 'Échéance',
        noDeadline: 'Aucune échéance',
        deadlineAt: 'Échéance au {date}',
        deadlinePassedSince: 'Échéance dépassée depuis le {date}',
        nextTask: 'Prochaine tâche : {title}',
        see: 'Voir',
        noFunnel: 'Vous n\'avez aucun tunnel de vente',
        create: 'Créer un tunnel de vente'
    },
    opportunities: {
        menu: 'Opportunités',
        label: 'Opportunité',
        reference: 'Opportunité n°{reference}',
        pageTitle: 'Liste des opportunités',
        newBtn: 'Nouvelle opportunité',
        createBtn: 'Créer une opportunité',
        addTitle: 'Création d\'une opportunité',
        editTitle: 'Modification d\'une opportunité',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette opportunité ?',
        documentType: 'Type de document',
        documentAttachExplain: 'Lorsqu\'un document est rattaché, tous ses documents liés seront automatiquement rattachés, incluant ceux qui seront créés ultérieurement.',
        attach: 'Rattacher',
        documentAttach: 'Rattacher un document',
        removeAttach: 'Supprimer le rattachement des documents',
        removeAttachMsg: 'Êtes-vous sûr de vouloir supprimer ce rattachement ?',
        nbForAmount: '{length} opportunités pour {amount}',
        form: {
            title: 'Titre',
            description: 'Description de l\'opportunité',
            funnel: 'Tunnel',
            step: 'Étape',
            category: 'Catégorie',
            amount: 'Montant estimatif',
            expire: 'Date d\'échéance',
            probability: 'Probabilité',
            commercial: 'Commercial',
            lossTitle: 'Perte de l\'opportunité',
            lossReason: 'Motif de perte de l\'opportunité :',
            lossComments: 'Commentaires :',
            pass: 'Passer'
        },
        list: {
            reference: 'N° opportunité',
            title: 'Titre',
            customer: 'Client',
            contact: 'Contact',
            amount: 'Montant',
            probability: 'Probabilité',
            status: 'Statut',
            expireAt: 'Échéance',
            category: 'Catégorie',
            step: 'Étape',
            funnel: 'Tunnel de vente',
            quotationCa: 'Devis - CA',
            quotationCosts: 'Devis - Coûts',
            quotationMargin: 'Devis - Marge',
            quotationValidCa: 'Devis acceptés - CA',
            quotationValidCosts: 'Devis acceptés - Coûts',
            quotationValidMargin: 'Devis acceptés - Marge',
            commandCa: 'Bons de commande - CA',
            commandCosts: 'Bons de commande - Coûts',
            commandMargin: 'Bons de commande - Marge',
            proformaCa: 'Factures Proforma - CA',
            proformaCosts: 'Factures proforma - Coûts',
            proformaMargin: 'Factures proforma - Marge',
            deliveryCa: 'Bons de livraison - CA',
            deliveryCosts: 'Bons de livraison - Coûts',
            deliveryMargin: 'Bons de livraison - Marge',
            invoiceCa: 'Factures - CA',
            invoiceCosts: 'Factures - Coûts',
            invoiceMargin: 'Factures - Marge',
            creditCa: 'Avoirs - CA',
            creditCosts: 'Avoirs - Coûts',
            creditMargin: 'Avoirs - Marge',
            salesCa: 'Ventes - CA',
            salesCosts: 'Ventes - Coûts',
            salesMargin: 'Ventes - Marge',
            commercial: 'Commercial',
            winnedAt: 'Date gagnée',
            losedAt: 'Date perdue',
            cancelledAt: 'Date annulée',
            createdAt: 'Date de création',
            updatedAt: 'Date de modification',
            lossReason: 'Motif de perte',
            lossReasonComments: 'Commentaires sur la perte'
        },
        item: {
            genericPageTitle: 'Fiche opportunité',
            pageTitle: 'Opportunité n°{reference}',
            new: 'Nouveau',
            status: 'Statut',
            step: 'Étape',
            customer: 'Client',
            contact: 'Contact',
            description: 'Description',
            winnedAt: 'Date gagnée',
            losedAt: 'Date perdue',
            lossReason: 'Motif de perte',
            lossReasonComments: 'Commentaires sur la perte',
            canceledAt: 'Date annulée',
            linkedDocuments: 'Documents liés',
            amountQuoted: 'Montants devisés',
            ca: 'CA',
            margin: 'Marge',
            costs: 'Coûts',
            acceptedQuotation: 'Devis acceptés',
            amountInvoiced: 'Montants facturés',
            element: 'Élément'
        },
        status: {
            1: 'En cours',
            2: 'Gagnée',
            3: 'Perdue',
            4: 'Annulée'
        }
    },
    lossReasons: {
        createTitle: 'Création d\'un motif de perte',
        updateTitle: 'Modification d\'un motif de perte',
        deleteMsg: 'Suppression d\'un motif de perte',
        label: 'Motif de perte',
        pageTitle: 'Gestion des motifs de perte',
        menu: 'Motifs de perte'
    }
};
var tasksLang = {
    searchTypes: {
        opportunity: 'Opportunité'
    }
};
var calendarsLang = {
    searchTypes: {
        opportunity: 'Opportunité'
    }
};
/* harmony default export */ var fr = ({
    opportunities: fr_opportunitiesLang,
    tasks: tasksLang,
    calendars: calendarsLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);

;// ./src/router/routes.ts
var routes_OpportunityListView = function () { return __webpack_require__.e(/* import() | opportunities */ 342).then(__webpack_require__.bind(__webpack_require__, 9945)); };
var routes_OpportunityItemView = function () { return __webpack_require__.e(/* import() | opportunities */ 342).then(__webpack_require__.bind(__webpack_require__, 4074)); };
var routes_FunnelsView = function () { return __webpack_require__.e(/* import() | opportunities */ 342).then(__webpack_require__.bind(__webpack_require__, 445)); };
var routes = function (i18n) { return ([
    {
        path: '/opportunities/funnels',
        name: 'funnels',
        component: routes_FunnelsView,
        meta: {
            title: i18n.t('opportunities.funnel.pageTitle'),
            pageHeader: false,
            appModule: 'opportunities',
            userPermission: ['opportunities', 1]
        }
    },
    {
        path: '/opportunities/opportunities',
        name: 'opportunity-list',
        component: routes_OpportunityListView,
        meta: {
            title: i18n.t('opportunities.opportunities.pageTitle'),
            appModule: 'opportunities',
            userPermission: ['opportunities', 1],
            pageHeader: false
        }
    },
    {
        path: '/opportunities/opportunities/:id',
        name: 'opportunity-item',
        component: routes_OpportunityItemView,
        meta: {
            title: i18n.t('opportunities.opportunities.item.genericPageTitle'),
            pageHeader: false,
            appModule: 'opportunities',
            userPermission: ['opportunities', 1],
            appClass: { 'opportunity-item': true }
        }
    }
]); };
/* harmony default export */ var router_routes = (routes);

;// ./src/router/configRoutes.ts
var configRoutes_ParamsView = function () { return __webpack_require__.e(/* import() | opportunities */ 342).then(__webpack_require__.bind(__webpack_require__, 6835)); };
var configRoutes_FunnelListView = function () { return __webpack_require__.e(/* import() | opportunities */ 342).then(__webpack_require__.bind(__webpack_require__, 9395)); };
var LossReasonListView = function () { return __webpack_require__.e(/* import() | opportunities */ 342).then(__webpack_require__.bind(__webpack_require__, 6467)); };
var configRoutes_routes = function (i18n) { return ([
    {
        name: 'opportunities-params',
        path: '/configuration/opportunities/params',
        component: configRoutes_ParamsView,
        meta: {
            title: i18n.t('opportunities.params.pageTitle'),
            appModule: 'opportunities',
            userPermission: ['app-configuration', 1]
        }
    },
    {
        name: 'opportunities-funnels',
        path: '/configuration/opportunities/funnels',
        component: configRoutes_FunnelListView,
        meta: {
            title: i18n.t('opportunities.funnels.pageTitle'),
            appModule: 'opportunities',
            userPermission: ['app-configuration', 1]
        }
    },
    {
        name: 'opportunities-loss-reasons',
        path: '/configuration/opportunities/loss-reasons',
        component: LossReasonListView,
        meta: {
            title: i18n.t('opportunities.lossReasons.pageTitle'),
            appModule: 'opportunities',
            userPermission: ['app-configuration', 1]
        }
    }
]); };
/* harmony default export */ var configRoutes = (configRoutes_routes);

;// ./src/dynamicModals.ts

var modals = [
    {
        key: 'opportunity-form',
        title: function (opportunity) { return opportunity && opportunity.id ? 'opportunities.opportunities.editTitle' : 'opportunities.opportunities.addTitle'; },
        component: OpportunityForm_OpportunityForm,
        size: 'lg'
    }
];
/* harmony default export */ var dynamicModals = (modals);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/store/modules/OpportunitiesStore.ts



var OpportunitiesStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(OpportunitiesStore, _super);
    function OpportunitiesStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.funnelsLoaded = false;
        _this.funnels = [];
        _this.lossReasonsLoaded = false;
        _this.lossReasons = [];
        return _this;
    }
    // CLEAR STORE STATE
    OpportunitiesStore.prototype.clearStore = function () {
        var _this = this;
        var elements = ['Funnels', 'LossReasons'];
        elements.forEach(function (key) {
            _this.context.commit('set' + key, []);
            _this.context.commit('set' + key + 'Loaded', false);
        });
    };
    // Sort a list alphabetically
    OpportunitiesStore.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key].toLowerCase();
            var bKey = b[key].toLowerCase();
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    Object.defineProperty(OpportunitiesStore.prototype, "funnelStep", {
        get: function () {
            var _this = this;
            return function (id) { var _a, _b; return (_b = (_a = _this.funnels.find(function (funnel) { return funnel.id === id; })) === null || _a === void 0 ? void 0 : _a.steps) !== null && _b !== void 0 ? _b : []; };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunitiesStore.prototype, "steps", {
        get: function () {
            var options = [];
            this.funnels.forEach(function (funnel) {
                var _a;
                options.push({
                    id: 'funnel-' + funnel.id,
                    name: funnel.name,
                    disable: true
                });
                (_a = funnel.steps) === null || _a === void 0 ? void 0 : _a.forEach(function (step) {
                    options.push(step);
                });
            });
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunitiesStore.prototype, "categories", {
        get: function () {
            var _this = this;
            return function (funnelId) {
                var _a, _b;
                return (_b = (_a = _this.funnels.find(function (funnel) { return funnel.id === funnelId; })) === null || _a === void 0 ? void 0 : _a.categories) !== null && _b !== void 0 ? _b : [];
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunitiesStore.prototype, "allCategories", {
        get: function () {
            var options = [];
            this.funnels.forEach(function (funnel) {
                var _a;
                options.push({
                    id: 'funnel-' + funnel.id,
                    label: funnel.name,
                    disable: true
                });
                (_a = funnel.categories) === null || _a === void 0 ? void 0 : _a.forEach(function (category) {
                    options.push(category);
                });
            });
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OpportunitiesStore.prototype, "availableFunnels", {
        get: function () {
            var _this = this;
            return this.funnels.filter(function (funnel) {
                var _a, _b;
                return !funnel.restricted || ((_b = (_a = funnel.team_users) === null || _a === void 0 ? void 0 : _a.findIndex(function (user) { return user.id === _this.context.rootGetters['user/teamUser'].id; })) !== null && _b !== void 0 ? _b : -1) >= 0;
            });
        },
        enumerable: false,
        configurable: true
    });
    // Change the loaded state
    OpportunitiesStore.prototype.setFunnelsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.funnelsLoaded = state;
    };
    // Set the funnels
    OpportunitiesStore.prototype.setFunnels = function (funnels) {
        this.funnels = funnels;
    };
    // Add or update a funnel
    OpportunitiesStore.prototype.updateFunnel = function (funnel) {
        if (!this.funnelsLoaded) {
            return;
        }
        var index = this.funnels.findIndex(function (type) { return type.id === funnel.id; });
        if (index >= 0) {
            external_vue_default().set(this.funnels, index, funnel);
        }
        else {
            this.funnels.push(funnel);
        }
    };
    // Remove a funnel
    OpportunitiesStore.prototype.removeFunnel = function (funnel) {
        if (!this.funnelsLoaded) {
            return;
        }
        var index = this.funnels.findIndex(function (type) { return type.id === funnel.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.funnels, index);
        }
    };
    // Load the funnels from server
    OpportunitiesStore.prototype.loadFunnels = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.funnelsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwOpportunities.axios.get('/opportunity/funnel?include=steps,categories,team_users&per_page=500&sort=name')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setFunnels', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setFunnelsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a funnel
    OpportunitiesStore.prototype.setFunnel = function (funnel) {
        this.context.commit('updateFunnel', funnel);
        if (this.funnelsLoaded) {
            this.context.commit('orderList', { list: this.funnels, key: 'name' });
        }
    };
    // Delete a funnel
    OpportunitiesStore.prototype.deleteFunnel = function (funnel) {
        this.context.commit('removeFunnel', funnel);
    };
    // Change the loaded state
    OpportunitiesStore.prototype.setLossReasonsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.lossReasonsLoaded = state;
    };
    // Set the loss reasons
    OpportunitiesStore.prototype.setLossReasons = function (lossReasons) {
        this.lossReasons = lossReasons;
    };
    // Add or update a loss reason
    OpportunitiesStore.prototype.updateLossReason = function (lossReason) {
        if (!this.lossReasonsLoaded) {
            return;
        }
        var index = this.lossReasons.findIndex(function (type) { return type.id === lossReason.id; });
        if (index >= 0) {
            external_vue_default().set(this.lossReasons, index, lossReason);
        }
        else {
            this.lossReasons.push(lossReason);
        }
    };
    // Remove a loss reason
    OpportunitiesStore.prototype.removeLossReason = function (lossReason) {
        if (!this.lossReasonsLoaded) {
            return;
        }
        var index = this.lossReasons.findIndex(function (type) { return type.id === lossReason.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.lossReasons, index);
        }
    };
    // Load the loss reasons from server
    OpportunitiesStore.prototype.loadLossReasons = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.lossReasonsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwOpportunities.axios.get('/opportunity/loss-reason?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setLossReasons', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setLossReasonsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a loss reason
    OpportunitiesStore.prototype.setLossReason = function (lossReason) {
        this.context.commit('updateLossReason', lossReason);
        if (this.lossReasonsLoaded) {
            this.context.commit('orderList', { list: this.lossReasons, key: 'label' });
        }
    };
    // Delete a loss reason
    OpportunitiesStore.prototype.deleteLossReason = function (lossReason) {
        this.context.commit('removeLossReason', lossReason);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "clearStore", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "orderList", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "setFunnelsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "setFunnels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "updateFunnel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "removeFunnel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "loadFunnels", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "setFunnel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "deleteFunnel", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "setLossReasonsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "setLossReasons", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "updateLossReason", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], OpportunitiesStore.prototype, "removeLossReason", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "loadLossReasons", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "setLossReason", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], OpportunitiesStore.prototype, "deleteLossReason", null);
    OpportunitiesStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], OpportunitiesStore);
    return OpportunitiesStore;
}(VuexModule));
/* harmony default export */ var modules_OpportunitiesStore = (OpportunitiesStore);

;// ./src/broadcasts/team.ts
/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.FunnelCreated',
        callback: function (funnel) {
            store.dispatch('opportunities/setFunnel', funnel);
        }
    },
    {
        name: '.FunnelUpdated',
        callback: function (funnel) {
            store.dispatch('opportunities/setFunnel', funnel);
        }
    },
    {
        name: '.FunnelDeleted',
        callback: function (funnel) {
            store.dispatch('opportunities/deleteFunnel', funnel);
        }
    }
]); });

;// ./src/install.ts







var KwixeoOpportunities = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        Vue.prototype.$kwOpportunities = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(1848);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            opportunities: modules_OpportunitiesStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
        // Register dynamicModals
        dynamicModals.forEach(function (modal) { return store.dispatch('dynamicModals/registerModal', modal); });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        router_routes(i18n).forEach(function (route) {
            router.addRoute(route);
        });
        configRoutes(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
    }
};
/* harmony default export */ var install = (KwixeoOpportunities);

;// ./src/index.ts

























// Vue X Modules





;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=opportunities.common.js.map